(function() {
    'use strict';

    angular
        .module('app.qa.questions_general', ['ngFileUpload', 'textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_questions_general', {
            url: '/qa/questions_general',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/qa-general/qa-general.html',
                    controller: 'QaGeneralController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_questions_general')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general')
        .controller('QuestionUploadController', QuestionUploadController);

    /** @ngInject */
    function QuestionUploadController(
        apiService,
        $mdDialog,
        theme,
        $scope,
        $timeout,
        Upload,
        $q
    ) {
        // data
        var vm = this;
        var QuestionGeneral = apiService.QuestionGeneral();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.isErrorUpload = false;
        vm.theme = theme;
        vm.form = {};
        vm.data = {
            file: null,
            pool_id: null
        };
        vm.listQuestionPool = [];
        vm.tempFile = undefined;
        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.validationLog = [];

        init();

        function init() {
            loadQuestionPool()
                .then(setQuestionPool)
                .finally(function() {
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 2000);
                });
        }

        function submit(ev, form) {
            vm.isLoading = true;
            vm.loadingMessage = 'Uploading Request';
            var fd = new FormData();
            for (var key in vm.data) {
                fd.append(key, vm.data[key]);
            }
            var request = QuestionGeneral.upload({}, fd);
            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.isErrorUpload = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                vm.isLoading = false;
                vm.validationLog = err.data.errors;
                vm.isErrorUpload = true;
                showDialog(ev, false, err.data);
            });
        }

        function loadQuestionPool() {
            var request = Ref.questionPool({ has_all: false });
            return request.$promise;
        }

        function setQuestionPool(data) {
            var defer = $q.defer();
            vm.listQuestionPool = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general')
        .controller('FormQaGeneralController', FormQaGeneralController);

    /** @ngInject */
    function FormQaGeneralController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q,
        Upload
    ) {
        // data
        var vm = this;
        var QuestionGeneral = apiService.QuestionGeneral();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.errorInit = false;
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            question: 'Write your question here',
            question_type: 'multiple',
            answers: [
                {
                    answer: '',
                    flag: 0,
                    is_update: false
                }
            ],
            image_temp: null
        };
        vm.listQuestionPool = [];
        vm.listQuestionCategory = [];

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.addAnswer = addAnswer;
        vm.minAnswer = minAnswer;
        vm.indexToAbjact = indexToAbjact;

        init();

        function init() {
            loadQuestionCategory()
                .then(setQuestionCategory)
                .then(loadQuestionPool)
                .then(setQuestionPool)
                .then(initFormData)
                .then(function() {
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                })
                .catch(function(err) {
                    vm.errorInit = true;
                    vm.errorMessage = 'Failed initializing data';
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                });
        }

        function initFormData() {
            var defer = $q.defer();
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.category_id = refData.question_category_id;
                vm.data.pool_id = refData.question_pool_id;
                vm.data.question_id = refData.question_id;
                vm.data.question = refData.question.question;
                vm.data.question_type = refData.question.type;
                vm.data.answers = [];
                refData.answers.map(function(val) {
                    vm.data.answers.push({
                        id: val.id,
                        flag: val.flag,
                        answer: val.answer,
                        is_update: true
                    });
                });
                if (refData.question.having_images == 1) {
                    loadImages(refData.question.images).then(function(images) {
                        vm.data.image_temp = images.data;
                    });
                }
                defer.resolve(true);
            } else {
                defer.resolve(true);
            }
            return defer.promise;
        }

        function addAnswer() {
            vm.data.answers.push({
                flag: false,
                answer: '',
                is_update: false
            });
        }

        function minAnswer(idx) {
            vm.data.answers.splice(idx, 1);
        }

        function loadImages(images) {
            var request = QuestionGeneral.images({ path: images });
            return request.$promise;
        }

        function submit(ev, form) {
            vm.isLoading = true;
            var checkImage = havingImages(vm.data);
            checkImage.then(function(res) {
                if (res.status) {
                    vm.data.image = res.image;
                }
                var request = QuestionGeneral.create(vm.data);
                vm.loadingMessage = 'Submitting Request';
                request.$promise.then(function(res) {
                    vm.isLoading = false;
                    showDialog(ev, true, res);
                });
                request.$promise.catch(function(err) {
                    form.$setPristine();
                    form.$setUntouched();
                    vm.isLoading = false;
                    showDialog(ev, false, err.data);
                });
            });
        }

        function update(ev, form) {
            vm.isLoading = true;
            var checkImage = havingImages(vm.data);
            checkImage.then(function(res) {
                if (res.status) {
                    vm.data.image = res.image;
                }
                var request = QuestionGeneral.update(vm.data);
                vm.loadingMessage = 'Updating Request';
                request.$promise.then(function(res) {
                    vm.isLoading = false;
                    showDialog(ev, true, res);
                });
                request.$promise.catch(function(err) {
                    form.$setPristine();
                    form.$setUntouched();
                    vm.isLoading = false;
                    showDialog(ev, false, err.data);
                });
            });
        }

        function havingImages(ref) {
            var defer = $q.defer();
            if (ref.image_temp) {
                Upload.dataUrl(ref.image_temp, true).then(function(url) {
                    defer.resolve({ status: true, image: url });
                });
            } else {
                defer.resolve({ status: false, image: null });
            }
            return defer.promise;
        }

        function loadQuestionPool() {
            var request = Ref.questionPool({ has_all: false });
            return request.$promise;
        }

        function loadQuestionCategory() {
            var request = Ref.questionCategory({ has_all: false });
            return request.$promise;
        }

        function setQuestionPool(data) {
            var defer = $q.defer();
            vm.listQuestionPool = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setQuestionCategory(data) {
            var defer = $q.defer();
            vm.listQuestionCategory = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function indexToAbjact(idx) {
            var abjacts = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
            return abjacts[idx];
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.pool', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_pool', {
            url: '/qa/pool',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/pool/pool.html',
                    controller: 'QaPoolController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_pool')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.pool')
        .controller('FormQaPoolController', FormQaPoolController);

    /** @ngInject */
    function FormQaPoolController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $q,
        $timeout
    ) {
        // data
        var vm = this;
        var Pool = apiService.Pool();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            name: '',
            description: ''
        };
        vm.listCompany = [];
        vm.listSubArea = [];

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.onCompanyChange = onCompanyChange;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                vm.data.sub_area_id = refData.sub_area.id;
                vm.data.company = refData.sub_area.company_id;
            }
            initFilter().then(function() {
                $timeout(function() {
                    vm.isLoading = false;
                }, 1000);
            });
        }

        function submit(ev, form) {
            var request = Pool.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Pool.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function loadSubArea() {
            var request = Ref.subArea({
                has_all: false,
                company: vm.data.company
            });
            return request.$promise;
        }

        function loadCompany() {
            var request = Ref.company({ has_all: false });
            return request.$promise;
        }

        function initFilter() {
            var defer = $q.defer();
            var company = loadCompany();
            company
                .then(setCompany)
                .then(loadSubArea)
                .then(setSubArea)
                .then(function() {
                    defer.resolve();
                })
                .catch(function() {
                    defer.reject();
                });

            return defer.promise;
        }

        function setCompany(response) {
            var defer = $q.defer();
            vm.listCompany = response;
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function setSubArea(response) {
            var defer = $q.defer();
            vm.listSubArea = response;
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function onCompanyChange() {
            loadSubArea().then(setSubArea);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.guides', ['ngFileUpload']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_guides', {
            url: '/qa/guides',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/guides/guides.html',
                    controller: 'QaGuidesController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_guides')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.guides')
        .controller('ViewGuidesController', ViewGuidesController);

    /** @ngInject */
    function ViewGuidesController(
        apiService,
        $mdDialog,
        theme,
        refData,
        $timeout,
        $sce
    ) {
        // data
        var vm = this;
        var Guides = apiService.Guides();
        vm.isLoading = true;
        vm.isErrorLoad = false;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.data = angular.copy(refData);
        vm.guide = null;

        init();

        function init() {
            loadGuide();
        }

        function loadGuide() {
            var request = Guides.loadGuide({ filename: vm.data.filename });
            request.$promise.then(function(blob) {
                blobToDataURL(blob.data, function(url) {
                    vm.guide = $sce.trustAsResourceUrl(url);
                });
            });
            request.$promise.catch(function(err) {
                vm.isErrorLoad = true;
            });
        }

        function blobToDataURL(blob, callback) {
            var a = new FileReader();
            a.onload = function(e) {
                callback(e.target.result);
            };
            a.readAsDataURL(blob);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.guides')
        .controller('FormGuidesController', FormGuidesController);

    /** @ngInject */
    function FormGuidesController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        Upload,
        $q
    ) {
        // data
        var vm = this;
        var Guides = apiService.Guides();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            title: '',
            description: ''
        };
        // vm.tempFile = null;

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.title = refData.title;
                vm.data.description = refData.description;
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 2000);
        }

        function submit(ev, form) {
            var request = Guides.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Guides.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.category', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_category', {
            url: '/qa/category',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/category/category.html',
                    controller: 'QaCategoryController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_category')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.category')
        .controller('FormCategoryController', FormCategoryController);

    /** @ngInject */
    function FormCategoryController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var Category = apiService.Category();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            name: '',
            description: '',
            code: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                vm.data.code = refData.code;
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Category.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Category.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.enrollment.session_group', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.enrollment_session_group', {
            url: '/enrollment/session_group',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/enrollment/session-group/session-group.html',
                    controller: 'SessionGroupController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.enrollment_session_group')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.enrollment.session_group')
        .controller('FormSessionGroupController', FormSessionGroupController);

    /** @ngInject */
    function FormSessionGroupController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q
    ) {
        // data
        var vm = this;
        var SessionGroup = apiService.SessionGroup();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            session_type: 'general',
            session_order: 1,
            session_duration: 120,
            question_limit: 0,
            users: []
        };
        vm.sessionType = ['general'];

        vm.questionPool = [];
        vm.guides = [];
        vm.searchText = '';

        // initialize date and time
        vm.tmpStartDate, vm.tmpEndDate, vm.tmpStartTime, vm.tmpEndTime;

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.getItemText = getItemText;
        vm.removeUsers = removeUsers;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                var temp = angular.copy(refData);
                setValueUpdate(temp);
            }

            loadQuestionPool()
                .then(loadGuides)
                .then(function() {
                    vm.errorMessage = '';
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                })
                .catch(function(err) {
                    vm.errorMessage = err;
                });
        }

        function setValueUpdate(data) {
            vm.data.id = data.id;
            vm.data.guides_id = data.guides_id;
            vm.data.question_limit = data.question_limit;
            vm.data.question_pool_id = data.question_pool_id;
            vm.data.session_type = data.session_type;
            vm.data.session_order = data.session_order;
            vm.data.session_duration = data.session_duration;
            vm.tmpStartDate = new Date(data.session_start_date);
            vm.tmpEndDate = new Date(data.session_end_date);
            vm.tmpStartTime = new Date(
                data.session_end_date + ' ' + data.session_start_time
            );
            vm.tmpEndTime = new Date(
                data.session_end_date + ' ' + data.session_end_time
            );
        }

        function loadQuestionPool() {
            var defer = $q.defer();
            var request = Ref.questionPool({ has_all: false });
            request.$promise.then(function(res) {
                vm.questionPool = res;
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.questionPool = [];
                defer.reject('FAILED LOAD QUESTION POOL');
            });
            return defer.promise;
        }

        function loadGuides() {
            var defer = $q.defer();
            var request = Ref.guides({ has_all: false });
            request.$promise.then(function(res) {
                vm.guides = res;
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.guides = [];
                defer.reject('FAILED LOAD GUIDES');
            });
            return defer.promise;
        }

        function submit(ev, form) {
            buildPayload(form);
            var request = SessionGroup.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            buildPayload(form);
            var request = SessionGroup.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function buildPayload(form) {
            vm.data.session_start_date = form.session_start_date.$viewValue;
            vm.data.session_end_date = form.session_end_date.$viewValue;
            vm.data.session_start_time = form.session_start_time.$viewValue + ':00';
            vm.data.session_end_time = form.session_end_time.$viewValue + ':00';
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function selectedItemChange(item) {
            if (item) {
                vm.data.users.push(item);
                vm.user = undefined;
                vm.searchText = '';
            }
        }

        function removeUsers(idx) {
            vm.data.users.splice(idx, 1);
        }

        function querySearch(query) {
            var request = Ref.users({ search: query });
            return request.$promise.then(function(response) {
                return response;
            });
        }

        function getItemText(item) {
            return item.nik + ' - ' + item.name;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.guides')
        .controller('ViewGuidesToolbarController', ViewGuidesToolbarController);

    /** @ngInject */
    function ViewGuidesToolbarController($mdDialog, theme, guide, $sce) {
        // data
        var vm = this;
        vm.isLoading = true;
        vm.isErrorLoad = false;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.theme = theme;
        vm.guide = guide;

        activate();

        function activate() {
            console.log(guide);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function() {
    'use strict';

    angular.module('app.report.detail', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report.detail', {
            url: '/detail/{achievement_id}',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/view-detail/view-detail.html',
                    controller: 'ReportViewDetailController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.report.detail')
        .controller('ReportViewDetailController', ReportViewDetailController);

    /** @ngInject */
    function ReportViewDetailController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $stateParams,
        $state
    ) {
        var vm = this;
        var Report = apiService.Report();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.achievementId = 0;
        vm.data = {
            achievement: {},
            detail: [],
            current: 1
        };
        vm.filter = {
            valid: false,
            invalid: false,
            not_answered: false
        };

        // method
        vm.renderIconFlag = renderIconFlag;
        vm.backToReport = backToReport;
        vm.filteredFlag = filteredFlag;

        activate();

        function activate() {
            vm.achievementId = $stateParams.achievement_id;
            loadData();
        }

        function loadData() {
            blockView.start({ message: 'Loading Report' });
            var request = Report.detail({ achievement_id: vm.achievementId });
            request.$promise.then(function(res) {
                vm.data = res.data;
                console.log(res);
                $timeout(function() {
                    blockView.stop();
                }, 1000);
            });
            request.$promise.catch(function() {
                vm.data = {
                    achievement: {},
                    detail: []
                };
                $timeout(function() {
                    blockView.stop();
                }, 1000);
            });
            return request.$promise;
        }

        function exportData() {
            var tmpStart = angular.copy(vm.tempStart);
            var tmpEnd = angular.copy(vm.tempEnd);
            var startDate = moment(tmpStart).format('YYYY-MM-DD');
            var endDate = moment(tmpEnd).format('YYYY-MM-DD');
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?start_date=' +
                startDate +
                '&end_date=' +
                endDate +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }

        function renderIconFlag(flag) {
            var icon = 'icon-alert-circle';
            switch (flag) {
                case 'VALID':
                    icon = 'icon-check green-400-fg';
                    break;
                case 'INVALID':
                    icon = 'icon-close red-400-fg';
                    break;
                case 'NOT_ANSWERED':
                    icon = 'icon-alert-circle grey-400-fg';
                    break;
            }
            return icon;
        }

        function backToReport() {
            $state.go('app.report');
        }

        function filteredFlag(item) {
            console.log(item);
            var filter = [];
            Object.keys(vm.filter).forEach(function(key) {
                if (vm.filter[key]) {
                    filter.push(key.toUpperCase());
                }
            });

            if (filter.length === 0) {
                return true;
            }

            return filter.indexOf(item.flag) !== -1;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.utility.menu', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.utility_menu', {
            url: '/utility/menu',
            views: {
                'content@app': {
                    templateUrl: 'app/main/utility/menu/menu.html',
                    controller: 'UtilityMenuController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.utility_menu')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.utility.menu')
        .controller('UtilityMenuController', UtilityMenuController);

    /** @ngInject */
    UtilityMenuController.$inject = [
        'apiService',
        'fuseTheming',
        '$mdDialog',
        '$timeout',
        'blockUI',
        '$mdToast',
        '$state',
        '$q',
        'toastr'
    ];

    function UtilityMenuController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q,
        toastr
    ) {
        var vm = this;
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = null;
        vm.listGroup = [
            { id: 1, name: 'super admin' },
            { id: 2, name: 'admin' }
        ];
        vm.isLoading = false;
        vm.listMenu = [];
        vm.loadData = loadData;
        vm.switchMenu = switchMenu;
        vm.switchAction = switchAction;

        function loadData() {
            blockView.start({ message: 'Please wait' });
            vm.isLoading = true;
            var request = Menu.view({ group_id: vm.group });
            request.$promise.then(function(res) {
                vm.listMenu = res;
                $timeout(function() {
                    blockView.stop();
                    vm.isLoading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.isLoading = false;
                $timeout(function() {
                    blockView.stop();
                }, 1000);
                vm.listMenu = [];
            });
        }

        function switchMenu(item) {
            blockView.start({ message: 'Please wait' });
            var payload = {
                group_id: vm.group,
                menu_id: item.id,
                is_enable: item.checked
            };
            var request = Menu.switchMenu(payload);
            request.$promise.then(function(res) {
                blockView.stop();
                toastr.success(res.message);
            });
            request.$promise.catch(function(res) {
                blockView.stop();
                toastr.error(res.data.message);
            });
            console.log(payload);
        }

        function switchAction(item) {
            blockView.start({ message: 'Please wait' });
            var payload = {
                group_id: vm.group,
                menu_id: item.menu_id,
                action_id: item.id,
                is_enable: item.checked
            };
            var request = Menu.switchAction(payload);
            request.$promise.then(function(res) {
                blockView.stop();
                toastr.success(res.message);
            });
            request.$promise.catch(function(res) {
                blockView.stop();
                toastr.error(res.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general')
        .controller('QaGeneralController', QaGeneralController);

    /** @ngInject */
    function QaGeneralController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $sce,
        $state
    ) {
        var vm = this;
        var QuestionGeneral = apiService.QuestionGeneral();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.questionPool = 'all';
        vm.questionCategory = 'all';
        vm.listQuestionPool = [];
        vm.listQuestionCategory = [];
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            changePassword: false,
            upload: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.getQuestionImages = getQuestionImages;
        vm.getQuestion = getQuestion;
        vm.uploadDialog = uploadDialog;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    initFilter().then(loadData(1));
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = QuestionGeneral.view({
                page: page,
                category_id: vm.questionCategory,
                competency_id: vm.competency,
                pool_id: vm.questionPool,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function initFilter() {
            var defer = $q.defer();
            blockView.start({ message: 'Initializing filter' });
            loadQuestionCategory()
                .then(setQuestionCategory)
                .then(loadQuestionPool)
                .then(setQuestionPool)
                .finally(function() {
                    blockView.stop();
                    defer.resolve(true);
                });

            return defer.promise;
        }

        function loadQuestionPool() {
            var request = Ref.questionPool({ has_all: true });
            return request.$promise;
        }

        function loadQuestionCategory() {
            var request = Ref.questionCategory({ has_all: true });
            return request.$promise;
        }

        function setQuestionPool(data) {
            var defer = $q.defer();
            vm.listQuestionPool = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setQuestionCategory(data) {
            var defer = $q.defer();
            vm.listQuestionCategory = data;
            defer.resolve(true);
            return defer.promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.code + ' will be deleted, are you sure ?';
                ref.push(item.question_id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = QuestionGeneral.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQaGeneralController as vm',
                    templateUrl: 'app/main/qa/qa-general/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'QuestionUploadController as vm',
                    templateUrl: 'app/main/qa/qa-general/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }

        function getQuestionImages(path, item) {
            var request = QuestionGeneral.images({ path: path });
            request.$promise.then(function(images) {
                var fileURL = URL.createObjectURL(images.data);
                item.question_image = fileURL;
            });
            request.$promise.catch(function(images) {
                item.question_image = 'assets/images/loader.svg';
            });
        }

        function getQuestion(question) {
            return $sce.trustAsHtml(question);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.pool').controller('QaPoolController', QaPoolController);

    /** @ngInject */
    function QaPoolController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Pool = apiService.Pool();
        var Menu = apiService.Menu();
        var Ref = apiService.Reference();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false
        };
        vm.listCompany = [];
        vm.listSubArea = [];
        vm.selectedCompany = 'all';
        vm.selectedSubArea = 'all';

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.onCompanyChange = onCompanyChange;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    initFilter().then(loadData.bind(1));
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Pool.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search,
                company: vm.selectedCompany,
                sub_area_id: vm.selectedSubArea
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Pool.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQaPoolController as vm',
                    templateUrl: 'app/main/qa/pool/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }

        function loadSubArea() {
            var request = Ref.subArea({
                has_all: true,
                company: vm.selectedCompany
            });
            return request.$promise;
        }

        function loadCompany() {
            var request = Ref.company({ has_all: true });
            return request.$promise;
        }

        function initFilter() {
            var defer = $q.defer();
            var company = loadCompany();
            company
                .then(setCompany)
                .then(loadSubArea)
                .then(setSubArea)
                .then(function() {
                    defer.resolve();
                })
                .catch(function() {
                    defer.reject();
                });

            return defer.promise;
        }

        function setCompany(response) {
            var defer = $q.defer();
            vm.listCompany = response;
            if (response.length > 0) {
                vm.selectedCompany = response[0];
            }
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function setSubArea(response) {
            var defer = $q.defer();
            vm.listSubArea = response;
            if (response.length > 0) {
                vm.selectedSubArea = response[0].id;
            }
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function onCompanyChange() {
            loadSubArea().then(setSubArea);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.guides')
        .controller('QaGuidesController', QaGuidesController);

    /** @ngInject */
    function QaGuidesController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Guides = apiService.Guides();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.viewDialog = viewDialog;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Guides.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.title + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Guides.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormGuidesController as vm',
                    templateUrl: 'app/main/qa/guides/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function viewDialog(ev, item) {
            ev.preventDefault();
            $mdDialog
                .show({
                    controller: 'ViewGuidesController as vm',
                    templateUrl: 'app/main/qa/guides/view/view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: item
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.category')
        .controller('QaCategoryController', QaCategoryController);

    /** @ngInject */
    function QaCategoryController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Category = apiService.Category();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Category.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Category.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormCategoryController as vm',
                    templateUrl: 'app/main/qa/category/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.enrollment.session_group')
        .controller('SessionGroupController', SessionGroupController);

    /** @ngInject */
    function SessionGroupController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $state
    ) {
        var vm = this;
        var SessionGroup = apiService.SessionGroup();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.date = 'all';
        vm.listDate = ['all'];
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                    getAvailableDate();
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = SessionGroup.view({
                page: page,
                date: vm.date,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function getAvailableDate() {
            var request = SessionGroup.getAvailableDate();
            request.$promise.then(function(res) {
                vm.listDate = res;
            });
            request.$promise.catch(function(err) {
                vm.listDate = ['all'];
            });
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = SessionGroup.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormSessionGroupController as vm',
                    templateUrl: 'app/main/enrollment/session-group/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.dashboard', ['chart.js']).config(config);

    /** @ngInject */
    function config($stateProvider, ChartJsProvider) {
        ChartJsProvider.setOptions({
            colors: [
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5'
            ]
        });
        // State
        $stateProvider.state('app.dashboard', {
            url: '/dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller: 'DashboardController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.dashboard')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('ViewUserDashboardController', ViewUserDashboardController);

    ViewUserDashboardController.$inject = [
        '$mdDialog',
        'theme',
        'refData',
        'dialogType',
        '$scope'
    ];

    /** @ngInject */
    function ViewUserDashboardController(
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope
    ) {
        // data
        var vm = this;
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = refData;
        vm.numPages = numPages;
        vm.filtered = [];
        vm.currentPage = 1;
        vm.numPerPage = 20;
        vm.totalItems = vm.data.length;
        vm.end = 1;

        // methods
        vm.cancel = cancel;
        vm.hide = hide;

        init();

        function init() {
            $scope.$watch('vm.currentPage + vm.numPerPage', function() {
                var begin = (vm.currentPage - 1) * vm.numPerPage;
                var end = begin + vm.numPerPage;
                vm.end = begin;
                vm.filtered = vm.data.slice(begin, end);
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function numPages() {
            return Math.ceil(vm.data.length / vm.numPerPage);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.clients', [
            'app.clients.menus',
            'app.clients.assessment_general'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients', {
            abstract: true,
            url: '/clients',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.clients': {
                    templateUrl: 'app/main/clients/clients.html',
                    controller: 'ClientsController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular.module('app.clients').directive('toolbarAssessment', toolbarAssessment);

    function toolbarAssessment() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/clients/toolbar/toolbar.directive.html',
            scope: {
                remainingTimes: '=',
                questions: '=',
                activeQuestion: '=',
                theme: '=',
                questionIndex: '=',
                scheme: '='
            },
            controller: ToolbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    ToolbarController.$inject = [
        '$scope',
        '$rootScope',
        '$interval',
        '$mdDialog',
        'apiService',
        'toastr',
        '$state'
    ];

    /** @ngInject */
    function ToolbarController(
        $scope,
        $rootScope,
        $interval,
        $mdDialog,
        apiService,
        toastr,
        $state
    ) {
        // Injecting $scope just for comparison
        var vm = this;
        var Assessment = apiService.Assessment();
        vm.$onInit = onInit;
        vm.fmtMSS = fmtMSS;
        vm.guide = null;
        vm.viewDialog = viewDialog;
        vm.timerSyncDelay = 10000;
        vm.isSyncRunning = false;
        vm.isInit = true;
        vm.submit = submit;

        function onInit() {
            $scope.$watch('vm.remainingTimes', function(nVal) {
                if (nVal) {
                    if (angular.isUndefined($rootScope.$timer)) {
                        startTimer();
                        initSync();
                    } else {
                        if (vm.remainingTimes <= 0) {
                            if (angular.isDefined($rootScope.$timer)) {
                                $interval.cancel($rootScope.$timer);
                            }
                            $rootScope.$broadcast('TIMER::TIME_IS_OVER', true);
                        }
                    }
                }
            });
        }

        function fmtMSS(s) {
            if (!s || s <= 0) {
                return '00:00';
            }
            return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
        }

        function startTimer() {
            if (vm.remainingTimes >= 0) {
                $rootScope.$timer = $interval(function() {
                    vm.remainingTimes -= 1;
                }, 1000);
            } else {
                if (angular.isDefined($rootScope.$timer)) {
                    $interval.cancel($rootScope.$timer);
                }
                $rootScope.$broadcast('TIMER::TIME_IS_OVER', true);
            }
        }

        $scope.$on('$destroy', function() {
            if (angular.isDefined($rootScope.$timer)) {
                $interval.cancel($rootScope.$timer);
                $rootScope.$timer = undefined;
            }
            if (angular.isDefined($rootScope.$timerSync)) {
                $interval.cancel($rootScope.$timerSync);
                $rootScope.$timerSync = undefined;
            }
        });

        $rootScope.$on('GUIDE::LOADED', function(ev, val) {
            vm.guide = val;
        });

        function viewDialog(ev) {
            ev.preventDefault();
            $mdDialog.show({
                controller: 'ViewGuidesToolbarController as vm',
                templateUrl: 'app/main/clients/toolbar/view-guide/view-guide.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                locals: {
                    theme: vm.theme.active.name,
                    guide: vm.guide
                }
            });
        }

        function initSync() {
            if (angular.isUndefined($rootScope.$timerSync)) {
                $rootScope.$timerSync = $interval(function() {
                    if (!vm.isSyncRunning && !vm.isInit) {
                        runSync(vm.scheme);
                    }
                    vm.isInit = false;
                }, vm.timerSyncDelay);
            }
        }

        function runSync(scheme) {
            vm.isSyncRunning = true;
            var request = Assessment.sync(scheme);
            request.$promise.then(function(res) {
                vm.isSyncRunning = false;
                // showMessage('success', 'Progress berhasil tersimpan');
            });
            request.$promise.catch(function(err) {
                vm.isSyncRunning = false;
                showMessage(
                    'error',
                    'Progress gagal tersimpan periksa kembali jaringan internet anda'
                );
            });
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function submit(ev) {
            if (vm.remainingTimes <= 20) {
                finalSubmit(ev);
                return;
            }
            var confirmation = confirmDialog(ev);
            confirmation.then(
                function() {
                    finalSubmit();
                },
                function() {
                    showMessage('info', 'Silahkan kembali mengerjakan test anda');
                }
            );
        }

        function finalSubmit(ev) {
            var request = Assessment.submit(vm.scheme);
            request.$promise.then(function(res) {
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(res) {
                showDialog(ev, false, res);
            });
        }

        function confirmDialog(ev) {
            var message =
                'Jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            if (vm.remainingTimes > 60) {
                message =
                    'Anda masih memiliki waktu untuk mengerjakan test, jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            }
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(message)
                .ariaLabel('Submit')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            return $mdDialog.show(confirm);
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    $state.go('app.clients.menus');
                });
        }

        function hide() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.menus', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.menus', {
            url: '/menu',
            views: {
                client_content: {
                    templateUrl: 'app/main/clients/menus/menus.html',
                    controller: 'ClientsMenusController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.clients.menus')
        .controller('ClientsMenusController', ClientsMenusController);

    /** @ngInject */
    function ClientsMenusController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $localStorage,
        $rootScope,
        $timeout
    ) {
        var vm = this;
        var blockContent = blockUI.instances.get('block-content');
        var Assessment = apiService.Assessment();
        vm.listSession = [];
        vm.launchTest = launchTest;
        vm.loadSession = loadSession;
        vm.isLoading = false;

        activate();

        function activate() {
            loadSession();
        }

        function loadSession() {
            vm.isLoading = true;
            var request = Assessment.session();
            request.$promise.then(function(res) {
                $timeout(function() {
                    vm.isLoading = false;
                }, 1000);
                vm.listSession = res.data;
                vm.message = res.message;
            });
            request.$promise.catch(function(res) {
                $timeout(function() {
                    vm.isLoading = false;
                }, 1000);
                vm.listSession = [];
                vm.message = res.data.message;
            });
        }

        function launchTest(item) {
            var params = {
                session_id: item.session_id,
                pool_id: item.pool_id,
                guide_id: item.guides_id
            };
            switch (item.session_type) {
                case 'general':
                    $state.go('app.clients.assessment_general', params);
                    break;
                default:
                    break;
            }
        }
    }
})();

(function() {
    'use strict';
    angular.module('app.clients').directive('guideAssessment', guideAssessment);

    function guideAssessment() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/clients/guides/guides.directive.html',
            scope: {
                sessionId: '=',
                isFinished: '=',
                onClickStart: '&',
                guideId: '='
            },
            controller: GuideController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    GuideController.$inject = ['$sce', 'apiService', '$q'];

    /** @ngInject */
    function GuideController($sce, apiService, $q) {
        // Injecting $rootScope just for comparison
        var vm = this;
        var Guide = apiService.Guides();
        vm.$onInit = onInit;
        vm.media = null;
        vm.title = 'This is guides';
        vm.description = 'This is description guides';
        vm.isErrorLoad = false;
        vm.isLoading = false;
        vm.getGuide = getGuide;

        function onInit() {
            if (!vm.isFinished) {
                getGuide();
            }
        }

        function getGuide() {
            vm.isLoading = true;
            var request = Guide.loadGuideById({ id: vm.guideId });
            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.isErrorLoad = false;
                vm.description = $sce.trustAsHtml(res.description);
                vm.title = res.title;
            });
            request.$promise.catch(function(err) {
                vm.description = 'Failed Load Guide';
                vm.title = 'Guide Not Found';
                vm.isLoading = false;
                vm.isErrorLoad = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.assessment_general', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.assessment_general', {
            url: '/general/{session_id}/{pool_id}/{guide_id}',
            views: {
                client_content: {
                    templateUrl:
                        'app/main/clients/assessment-general/assessment-general.html',
                    controller: 'AssessmentGeneralController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.clients.assessment_general')
        .controller('AssessmentGeneralController', AssessmentGeneralController);

    /** @ngInject */
    function AssessmentGeneralController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $localStorage,
        $scope,
        $stateParams,
        $q,
        $mdDialog,
        fuseTheming,
        $rootScope,
        toastr,
        $interval
    ) {
        var vm = this;
        var blockContent = blockUI.instances.get('block-content');
        var Assessment = apiService.Assessment();
        var QuestionGeneral = apiService.QuestionGeneral();
        vm.themes = fuseTheming.themes;
        vm.scheme = {};
        vm.params = {
            session_type: 'general',
            pool_id: $stateParams.pool_id,
            session_id: $stateParams.session_id,
            guide_id: $stateParams.guide_id
        };
        vm.activeQuestion = {};
        vm.start = start;
        vm.isGuideFinish = false;
        vm.isLoading = false;
        vm.questionIndex = 0;
        vm.syncDelay = 10000; // in ms
        vm.isSyncRunning = false;
        vm.countdownExp = 30;
        vm.countdownInterval = undefined;
        vm.timeIsOver = false;
        vm.isLastQuestion = false;
        vm.isFirstQuestion = false;

        vm.setQuestion = setQuestion;
        vm.getQuestionImages = getQuestionImages;
        vm.prevQuestion = prevQuestion;
        vm.nextQuestion = nextQuestion;
        vm.onAnswerChange = onAnswerChange;
        vm.goToMenu = goToMenu;

        activate();

        function activate() {
            checkGuideIsRead().then(function(status) {
                if (status) {
                    init();
                }
            });
        }

        function init() {
            vm.isGuideFinish = true;
            loadQuestion()
                .then(initQuestion)
                .catch(function(err) {
                    vm.scheme = {};
                });

            $scope.$on('GENERAL::QUESTION_RELOAD', function() {
                loadQuestion();
            });
            $scope.$on('TIMER::TIME_IS_OVER', function(ev, val) {
                vm.timeIsOver = val;
            });
        }

        function initQuestion(scheme) {
            vm.scheme = scheme.data;
            vm.questionIndex = getLastIndex(vm.scheme.questions);
            vm.activeQuestion = vm.scheme.questions[vm.questionIndex];
            if (vm.questionIndex === 0) {
                vm.isFirstQuestion = true;
            }
            if (!vm.scheme.is_valid) {
                setCountdownExpired();
            }
        }

        function loadQuestion() {
            var request = Assessment.question(vm.params);
            return request.$promise;
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(init);
        }

        function checkGuideIsRead() {
            var defer = $q.defer();
            var request = Assessment.isGuideRead({
                session_id: vm.params.session_id
            });
            request.$promise.then(function(res) {
                defer.resolve(res.status);
            });
            request.$promise.catch(function() {
                defer.reject(false);
            });
            return defer.promise;
        }

        function setQuestion(idx) {
            vm.isLastQuestion = false;
            vm.isFirstQuestion = false;

            var answered = vm.activeQuestion.answers.filter(function(val) {
                return val.checked;
            });

            if (idx === 0) {
                vm.isFirstQuestion = true;
            }

            if (answered.length !== 0) {
                if (vm.activeQuestion.total_answer !== answered.length) {
                    showMessage(
                        'warning',
                        'Pertanyaan ini membutuhkan ' +
                            vm.activeQuestion.total_answer +
                            ' jawaban'
                    );
                    return;
                }
            }

            vm.activeQuestion = vm.scheme.questions[idx];
            vm.questionIndex = idx;

            if (vm.scheme.questions.length - 1 == idx) {
                vm.isLastQuestion = true;
            }
            setLastIndex(idx);
        }

        function getQuestionImages(path) {
            var defer = $q.defer();
            var request = QuestionGeneral.images({ path: path });
            request.$promise.then(function(images) {
                var fileURL = URL.createObjectURL(images.data);
                defer.resolve(fileURL);
            });
            request.$promise.catch(function(images) {
                defer.resolve('assets/images/loader.svg');
            });
            return defer.promise;
        }

        function nextQuestion() {
            var questionIdx = angular.copy(vm.questionIndex);
            var nextIdx = questionIdx + 1;
            var questionTotalIdx = vm.scheme.questions.length - 1;
            if (nextIdx > questionTotalIdx) {
                showMessage('info', 'ini adalah pertanyaan terakhir');
                return;
            }
            setQuestion(nextIdx);
            vm.questionIdx = nextIdx;
        }

        function prevQuestion() {
            vm.isLastQuestion = false;
            var questionIdx = angular.copy(vm.questionIndex);
            var prevIdx = questionIdx - 1;
            if (prevIdx < 0) {
                showMessage('info', 'Ini adalah pertanyaan pertama');
                return;
            }
            setQuestion(prevIdx);
            vm.questionIdx = prevIdx;
        }

        function getLastIndex(data) {
            var lastIndex = 0;
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].is_last_index) {
                        lastIndex = i;
                        break;
                    }
                }
            }
            return lastIndex;
        }

        function setLastIndex(idx) {
            vm.scheme.questions.map(function(val) {
                val.is_last_index = false;
            });
            vm.scheme.questions[idx].is_last_index = true;
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function onAnswerChange() {
            var ctr = 0;

            for (var i = 0; i < vm.activeQuestion.answers.length; i++) {
                var element = vm.activeQuestion.answers[i];
                if (element.checked) {
                    ctr += 1;
                }
            }

            if (ctr > 0) {
                vm.activeQuestion.is_submitted = true;
            } else {
                vm.activeQuestion.is_submitted = false;
            }
        }

        function setCountdownExpired() {
            vm.countdownInterval = $interval(function() {
                vm.countdownExp -= 1;
                if (vm.countdownExp <= 0) {
                    $interval.cancel(vm.countdownInterval);
                    goToMenu();
                }
            }, 1000);
        }

        function goToMenu() {
            $state.go('app.clients.menus');
        }

        $scope.$on('$destroy', function() {
            if (angular.isDefined(vm.countdownInterval)) {
                $interval.cancel(vm.countdownInterval);
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.account', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.account', {
            url: '/account',
            views: {
                'content@app': {
                    templateUrl: 'app/main/account/account.html',
                    controller: 'AccountController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.account')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.account')
        .controller(
            'ChangePasswordAccountController',
            ChangePasswordAccountController
        );

    ChangePasswordAccountController.$inject = [
        'apiService',
        '$mdDialog',
        'theme',
        'refData',
        '$scope',
        '$timeout'
    ];

    /** @ngInject */
    function ChangePasswordAccountController(
        apiService,
        $mdDialog,
        theme,
        refData,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var Account = apiService.Account();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.data = {
            password: '',
            password_confirmation: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;

        init();

        function init() {
            vm.data.nik = refData.nik;
            vm.data.name = refData.name;
            vm.data.group = refData.roles.gid;
            vm.data.roles_id = refData.roles.id;
            vm.data.user_id = refData.id;
            initWatcher();
            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Account.changePassword(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function initWatcher() {
            $scope.$watch('vm.data.password_confirmation', function(nVal) {
                if (nVal && !angular.equals(vm.form, {})) {
                    if (nVal !== vm.data.password) {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            false
                        );
                    } else {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            true
                        );
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.account')
        .controller('FormAccountController', FormAccountController);

    FormAccountController.$inject = [
        'apiService',
        '$mdDialog',
        'theme',
        'refData',
        'dialogType',
        '$scope',
        '$timeout'
    ];

    /** @ngInject */
    function FormAccountController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var Account = apiService.Account();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.listGroup = [
            { id: 1, name: 'super admin' },
            { id: 2, name: 'admin' },
            { id: 3, name: 'user' }
        ];
        vm.data = {
            password: '',
            password_confirmation: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.nik = refData.nik;
                vm.data.name = refData.name;
                vm.data.group = refData.roles.gid;
                vm.data.roles_id = refData.roles.id;
                vm.data.user_id = refData.id;
            } else {
                initWatcher();
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Account.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Account.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function initWatcher() {
            $scope.$watch('vm.data.password_confirmation', function(nVal) {
                if (nVal && !angular.equals(vm.form, {})) {
                    if (nVal !== vm.data.password) {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            false
                        );
                    } else {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            true
                        );
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.core', [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'pascalprecht.translate',
        'ui.router',
        'blockUI',
        'ngStorage',
        'angular-jwt',
        'angularUtils.directives.dirPagination',
        'toastr'
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout) {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        vm.blurred = blurred;

        //////////

        // init();

        function init() {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function(current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                if (vm.collapsed) {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {
                        query: current
                    }),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = onSearchEvaluated && !!onSearchEvaluated.then;

                if (isArray) {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if (isPromise) {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated
                        .then(
                            // Success
                            function(response) {
                                // Populate the results
                                vm.populateResults(response);
                            },
                            // Error
                            function() {
                                // Assign an empty array to show
                                // the no-results screen
                                vm.populateResults([]);
                            }
                        )
                        .finally(function() {
                            // Hide the loader
                            vm.resultsLoading = false;
                        });
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results) {
            // Before doing anything,
            // make sure the search bar is expanded
            if (vm.collapsed) {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if (!isArray && !isNull) {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand() {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if (vm.onExpand && angular.isFunction(vm.onExpand)) {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if (vm.onCollapse && angular.isFunction(vm.onCollapse)) {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:
                    // Trigger result click
                    // vm.handleResultClick(vm.results[vm.selectedResultIndex]);
                    $scope.$parent.$eval(vm.onSearch);
                    break;

                // Escape
                case 27:
                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:
                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:
                    if (!vm.results) {
                        return;
                    }

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function() {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            if (vm.onResultClick) {
                vm.onResultClick({ item: item });
            }

            // Collapse the search bar
            // vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(
                    resultsEl.find('.result')[vm.selectedResultIndex]
                );

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom =
                        selectedItemEl.position().top +
                        selectedItemEl.outerHeight() +
                        8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > resultsEl.height() + resultsEl.scrollTop()) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Ensure the query field
         * if not empty
         * cannot collapse
         */
        function blurred() {
            if (!vm.query) {
                vm.collapse();
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document) {
        return {
            restrict: 'E',
            scope: {},
            require: 'msSearchBar',
            controller: 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce: '=?',
                onSearch: '@',
                onResultClick: '&?',
                onExpand: '&?',
                onCollapse: '&?',
                query: '=?'
            },
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile: function(tElement) {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement) {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand() {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse() {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('app.core').directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                card: '=ngModel',
                vm: '=viewModel'
            },
            template:
                '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile: function(tElement) {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded() {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('titleCase', titleCase)
        .filter('trustResourceUrl', trustResourceUrl);

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function(value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function(text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function(value) {
            return !value ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function(doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function titleCase() {
        return function(input) {
            input = input || '';
            return input.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        };
    }

    /** @ngInject */
    function trustResourceUrl($sce) {
        return function(val) {
            return $sce.trustAsResourceUrl(val);
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function() {
    'use strict';

    angular.module('app.unauthorized', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.unauthorized', {
            url: '/unauthorized',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.unauthorized': {
                    templateUrl: 'app/main/unauthorized/unauthorized.html',
                    controller: 'UnauthorizedController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.unauthorized')
        .controller('UnauthorizedController', UnauthorizedController);

    UnauthorizedController.$inject = [];

    /** @ngInject */
    function UnauthorizedController() {
        var vm = this;
    }
})();

(function() {
    'use strict';

    angular.module('app.report', ['app.report.detail']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report', {
            url: '/report',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/report.html',
                    controller: 'ReportController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.report')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.report').controller('ReportController', ReportController);

    /** @ngInject */
    function ReportController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $state
    ) {
        var vm = this;
        var Report = apiService.Report();
        var Ref = apiService.Reference();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.groupParticipant = 'all';
        vm.tempStart = new Date('2019-11-06');
        vm.tempEnd = new Date();
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.loadData = loadData;
        vm.exportData = exportData;
        vm.goToDetail = goToDetail;

        activate();

        function activate() {
            vm.pagination.is_loading = true;
            loadData(1);
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var startDate = angular.copy(vm.tempStart);
            var endDate = angular.copy(vm.tempEnd);
            var request = Report.view({
                page: page,
                page_size: vm.pagination.page_size,
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
                group_participant: vm.groupParticipant,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function goToDetail(item) {
            $state.go('app.report.detail', { achievement_id: item.id });
        }

        function exportData() {
            var tmpStart = angular.copy(vm.tempStart);
            var tmpEnd = angular.copy(vm.tempEnd);
            var startDate = moment(tmpStart).format('YYYY-MM-DD');
            var endDate = moment(tmpEnd).format('YYYY-MM-DD');
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?start_date=' +
                startDate +
                '&end_date=' +
                endDate +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.sample', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.sample', {
            url: '/sample',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sample/sample.html',
                    controller: 'SampleController as vm'
                }
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function() {
    'use strict';

    angular.module('app.login', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.login').controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        $mdToast,
        $state,
        authService,
        blockUI,
        apiService,
        $localStorage,
        $rootScope,
        $q,
        appConfig,
        $timeout
    ) {
        var vm = this;
        var blockLogin = blockUI.instances.get('loginForm');
        vm.login = login;
        vm.form = {
            username: '',
            password: ''
        };
        vm.config = appConfig;
        vm.isPushed = false;
        vm.authType = '';

        // Methods

        activate();

        function activate() {
            $rootScope.$broadcast('LOGIN::LOADED');
        }

        function login() {
            blockLogin.start({ message: 'Signing In' });
            var request = authService.login(
                vm.form.username,
                vm.form.password,
                vm.authType
            );
            request.then(function(res) {
                authService.setToken(res.data);
                authService.stateRedirector().then(function(redirector) {
                    if (redirector.state.indexOf('clients') !== -1) {
                        isDone(
                            true,
                            'Redirecting to playground',
                            1000,
                            redirector.state
                        );
                    } else {
                        setMenu(redirector.state);
                    }
                });
            });

            request.catch(function(err) {
                isDone(false, err.data.message, 2000);
            });
        }

        function showAlert(status, message, delay, redirectTo) {
            $mdToast
                .show(
                    $mdToast
                        .simple()
                        .textContent(message)
                        .position('bottom right')
                        .hideDelay(delay)
                )
                .then(function() {
                    if (status) {
                        $state.go(redirectTo);
                    }
                });
        }

        function getMenu() {
            var menu = apiService.Menu();
            var request = menu.getMenu();
            return request.$promise;
        }

        function isDone(status, message, delay, redirectTo) {
            setTimeout(function() {
                showAlert(status, message, delay, redirectTo);
            }, 1000);
            setTimeout(function() {
                blockLogin.stop();
            }, 1000);
        }

        function setMenu(redirector) {
            getMenu()
                .then(function(menu) {
                    $localStorage.menus = menu.data;
                    $rootScope.$broadcast('MENU::LOADED');
                    isDone(
                        true,
                        'Success, Redirecting to Dashboard',
                        1000,
                        redirector
                    );
                })
                .catch(function() {
                    isDone(false, 'You are not registered', 2000, redirector);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = [
        '$q',
        'apiService',
        '$timeout',
        'blockUI',
        '$state',
        '$mdDialog',
        'fuseTheming'
    ];

    /** @ngInject */
    function DashboardController(
        $q,
        apiService,
        $timeout,
        blockUI,
        $state,
        $mdDialog,
        fuseTheming
    ) {
        var vm = this;
        var Dashboard = apiService.Dashboard();
        var Ref = apiService.Reference();
        var blockLatestSubmit = blockUI.instances.get('block-latest-submit');
        var blockMostQuestion = blockUI.instances.get('block-most-question');
        var blockChart = blockUI.instances.get('block-chart');
        vm.themes = fuseTheming.themes;
        var date = new Date();
        vm.isLoading = {
            widget: false,
            questionStats: false
        };
        vm.questionStats = {
            correct: [],
            incorrect: []
        };
        vm.listCompany = [];
        vm.listSubArea = [];
        vm.selectedCompany = 'all';
        vm.selectedSubArea = 'all';

        vm.date = moment(date)
            .locale('id')
            .format('YYYY-MM-DD hh:mm:ss');

        vm.widget = {
            active_session: 0,
            percentage_finished: 0,
            percentage_in_init: 0,
            percentage_in_progress: 0,
            percentage_total_user_online: 0,
            percentage_total_user_test: 0,
            today_finished: 0,
            today_in_init: 0,
            today_in_progress: 0,
            total_user: 0,
            total_user_online: 0,
            total_user_taken_test: 0,
            total_user_test: 0
        };

        vm.paginationSubmit = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 5,
            is_loading: true,
            is_error: false
        };

        vm.userStats = {
            labels: [],
            data: []
        };

        vm.chartOptions = {
            legend: {
                display: true
            },
            layout: {
                padding: {
                    left: 50,
                    right: 10,
                    top: 20,
                    bottom: 20
                }
            },
            title: {
                display: true,
                text: 'Total Participant Statistics'
            }
        };

        vm.getPercentage = getPercentage;
        vm.reloadData = reloadData;
        vm.onPageChange = onPageChange;
        vm.goToDetail = goToDetail;
        vm.showDialog = showDialog;
        vm.onCompanyChange = onCompanyChange;

        activate();

        function activate() {
            initFilter().then(function() {
                loadWidget()
                    .then(loadData.bind(1))
                    .then(loadQuestionStats)
                    .then(loadChartUserStats)
                    .then(function() {});
            });
        }

        function reloadData() {
            loadQuestionStats();
            loadWidget().then(function() {
                var dt = new Date();
                vm.date = moment(dt)
                    .locale('id')
                    .format('YYYY-MM-DD hh:mm:ss');
            });
            loadChartUserStats();
        }

        function loadWidget() {
            vm.isLoading.widget = true;
            var defer = $q.defer();
            var dt = moment(date).format('YYYY-MM-DD');
            var request = Dashboard.loadWidget({
                date: dt,
                company: vm.selectedCompany,
                sub_area_id: vm.selectedSubArea
            });
            request.$promise.then(function(res) {
                vm.widget = res.data;
                vm.isLoading.widget = false;
                defer.resolve();
            });
            request.$promise.catch(function() {
                vm.isLoading.widget = false;
                vm.widget = {
                    active_session: 0,
                    percentage_finished: 0,
                    percentage_in_init: 0,
                    percentage_in_progress: 0,
                    percentage_total_user_online: 0,
                    percentage_total_user_test: 0,
                    today_finished: 0,
                    today_in_init: 0,
                    today_in_progress: 0,
                    total_user: 0,
                    total_user_online: 0,
                    total_user_taken_test: 0,
                    total_user_test: 0
                };
                defer.reject();
            });
            return defer.promise;
        }

        function loadData(page) {
            vm.paginationSubmit.current = page;
            vm.paginationSubmit.is_loading = true;
            blockLatestSubmit.start({ message: 'Please wait' });
            var dt = moment(date).format('YYYY-MM-DD');
            var request = Dashboard.loadLatestSubmit({
                page: page,
                page_size: vm.paginationSubmit.page_size,
                date: dt,
                search: vm.paginationSubmit.search,
                company: vm.selectedCompany,
                sub_area_id: vm.selectedSubArea
            });
            request.$promise.then(function(res) {
                vm.paginationSubmit.page_size = res.per_page;
                vm.paginationSubmit.from = res.from;
                vm.paginationSubmit.data = res.data;
                vm.paginationSubmit.total = res.total;
                vm.paginationSubmit.is_error = false;
                $timeout(function() {
                    vm.paginationSubmit.is_loading = false;
                    blockLatestSubmit.stop();
                }, 1000);
            });
            request.$promise.catch(function(res) {
                blockLatestSubmit.stop();
                vm.paginationSubmit.page_size = res.per_page;
                vm.paginationSubmit.from = res.from;
                vm.paginationSubmit.data = res.data;
                vm.paginationSubmit.total = res.total;
                vm.paginationSubmit.is_loading = false;
                vm.paginationSubmit.is_error = true;
            });

            return request.$promise;
        }

        function loadChartUserStats() {
            var defer = $q.defer();
            var request = Dashboard.getChartUserStats();
            blockChart.start({ message: 'Please wait' });
            request.$promise.then(function(res) {
                defer.resolve();
                vm.userStats = res;
                blockChart.stop();
            });
            request.$promise.catch(function(res) {
                defer.reject();
                vm.userStats = {
                    labels: [],
                    data: []
                };
                blockChart.stop();
            });
            return defer.promise;
        }

        function loadQuestionStats() {
            var defer = $q.defer();
            var request = Dashboard.getQuestionStats();
            vm.isLoading.questionStats = true;
            blockMostQuestion.start({ message: 'Please wait' });
            request.$promise.then(function(stats) {
                defer.resolve();
                vm.questionStats = stats;
                vm.isLoading.questionStats = false;
                $timeout(function() {
                    blockMostQuestion.stop();
                }, 1000);
            });
            request.$promise.catch(function(stats) {
                vm.questionStats = {
                    correct: [],
                    incorrect: []
                };
                defer.reject();
                vm.isLoading.questionStats = false;
                $timeout(function() {
                    blockMostQuestion.stop();
                }, 1000);
            });
            return defer.promise;
        }

        function getPercentage(item, divider) {
            if (divider == 0) {
                return 0;
            }
            return (item / divider) * 100;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function goToDetail(item) {
            $state.go('app.report.detail', { achievement_id: item.id });
        }

        function showDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'ViewUserDashboardController as vm',
                    templateUrl: 'app/main/dashboard/view-user/view-user.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        // loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function initFilter() {
            var defer = $q.defer();
            var company = loadCompany();
            company
                .then(setCompany)
                .then(loadSubArea)
                .then(setSubArea)
                .then(function() {
                    defer.resolve();
                })
                .catch(function() {
                    defer.reject();
                });

            return defer.promise;
        }

        function loadSubArea() {
            var request = Ref.subArea({
                has_all: true,
                company: vm.selectedCompany
            });
            return request.$promise;
        }

        function loadCompany() {
            var request = Ref.company({ has_all: true });
            return request.$promise;
        }

        function setCompany(response) {
            var defer = $q.defer();
            vm.listCompany = response;
            if (response.length > 0) {
                vm.selectedCompany = response[0];
            }
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function setSubArea(response) {
            var defer = $q.defer();
            vm.listSubArea = response;
            if (response.length > 0) {
                vm.selectedSubArea = response[0].id;
            }
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function onCompanyChange() {
            loadSubArea().then(setSubArea);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.clients').controller('ClientsController', ClientsController);

    /** @ngInject */
    function ClientsController($state, $rootScope) {
        var vm = this;
        vm.reloadScheme = reloadScheme;
        vm.logout = logout;

        init();

        function init() {}

        function reloadScheme() {
            $rootScope.$broadcast('GENERAL::QUESTION_RELOAD');
        }

        function logout() {
            $state.go('app.login');
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.account').controller('AccountController', AccountController);

    AccountController.$inject = [
        'apiService',
        'fuseTheming',
        '$mdDialog',
        '$timeout',
        'blockUI',
        '$mdToast',
        '$state',
        '$q'
    ];

    /** @ngInject */
    function AccountController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Account = apiService.Account();
        var Menu = apiService.Menu();
        var Ref = apiService.Reference();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            changePassword: false,
            upload: false,
            create: false
        };
        vm.listCompany = [];
        vm.listSubArea = [];
        vm.selectedCompany = 'all';
        vm.selectedSubArea = 'all';

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.changePassword = changePassword;
        vm.onCompanyChange = onCompanyChange;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    initFilter().then(loadData.bind(1));
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Account.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search,
                company: vm.selectedCompany,
                sub_area_id: vm.selectedSubArea
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.nik + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Account.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            vm.pagination.current = pageNumber;
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormAccountController as vm',
                    templateUrl: 'app/main/account/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function changePassword(ev, ref) {
            $mdDialog
                .show({
                    controller: 'ChangePasswordAccountController as vm',
                    templateUrl:
                        'app/main/account/change-password/change-password.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }

        function loadSubArea() {
            var request = Ref.subArea({
                has_all: true,
                company: vm.selectedCompany
            });
            return request.$promise;
        }

        function loadCompany() {
            var request = Ref.company({ has_all: true });
            return request.$promise;
        }

        function initFilter() {
            var defer = $q.defer();
            var company = loadCompany();
            company
                .then(setCompany)
                .then(loadSubArea)
                .then(setSubArea)
                .then(function() {
                    defer.resolve();
                })
                .catch(function() {
                    defer.reject();
                });

            return defer.promise;
        }

        function setCompany(response) {
            var defer = $q.defer();
            vm.listCompany = response;
            if (response.length > 0) {
                vm.selectedCompany = response[0];
            }
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function setSubArea(response) {
            var defer = $q.defer();
            vm.listSubArea = response;
            if (response.length > 0) {
                vm.selectedSubArea = response[0].id;
            }
            $timeout(function() {
                defer.resolve();
            }, 200);
            return defer.promise;
        }

        function onCompanyChange() {
            loadSubArea().then(setSubArea);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes) {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if (customTheme) {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function(palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function(theme, themeName) {
            $mdThemingProvider
                .theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }
})();

(function() {
    'use strict';

    var fuseThemes = {
        default: {
            primary: {
                name: 'fuse-paleblue',
                hues: {
                    default: '700',
                    'hue-1': '500',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'light-blue',
                hues: {
                    default: '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        },
        pinkTheme: {
            primary: {
                name: 'blue-grey',
                hues: {
                    default: '900',
                    'hue-1': '700',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'pink',
                hues: {
                    default: '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'brown',
                hues: {
                    default: '500',
                    'hue-1': '300',
                    'hue-2': '800',
                    'hue-3': 'A100'
                }
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        },
        tealTheme: {
            primary: {
                name: 'blue-grey',
                hues: {
                    default: '900',
                    'hue-1': '600',
                    'hue-2': '500',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'teal',
                hues: {
                    default: '500',
                    'hue-1': '400',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'deep-orange',
                hues: {
                    default: '500',
                    'hue-1': '300',
                    'hue-2': '800',
                    'hue-3': 'A100'
                }
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        },
        redTheme: {
            primary: {
                name: 'blue-grey',
                hues: {
                    default: '900',
                    'hue-1': '700',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'red',
                hues: {
                    default: '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'amber',
                hues: {
                    default: '500',
                    'hue-1': '300',
                    'hue-2': '800',
                    'hue-3': 'A100'
                }
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        }
    };

    angular.module('app.core').constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('app.core').factory('authService', AuthService);

    /** @ngInject */
    function AuthService($localStorage, $location, jwtHelper, apiService, $q) {
        var service = {
            login: login,
            refreshToken: refreshToken,
            logout: logout,
            isAuthenticated: isAuthenticated,
            setToken: setToken,
            getToken: getToken,
            clearToken: clearToken,
            stateRedirector: stateRedirector,
            hasAccess: hasAccess,
            redirectToLogin: redirectToLogin
        };

        return service;

        function isAuthenticated() {
            return typeof $localStorage.token !== 'undefined';
        }

        function login(username, password, authType) {
            var auth = apiService.Auth();
            var request = auth.login({
                username: username,
                password: password,
                authType: authType
            });
            return request.$promise;
        }

        function refreshToken() {
            var auth = apiService.Auth();
            var request = auth.refresh({
                token: getToken()
            });
            return request.$promise;
        }

        function logout() {
            var auth = apiService.Auth();
            var request = auth.logout({
                token: getToken()
            });
            request.$promise.then(redirectToLogin);
            request.$promise.catch(redirectToLogin);
            return true;
        }

        function setToken(token) {
            try {
                var decoded = jwtHelper.decodeToken(token);
                var data = decoded.data;
                Object.keys(data).forEach(function(key) {
                    $localStorage[key] = data[key];
                });
                $localStorage.token = token;
                return true;
            } catch (error) {
                console.log('setToken', error);
                return false;
            }
        }

        function getToken() {
            var token = angular.copy($localStorage.token);
            return token;
        }

        function clearToken() {
            delete $localStorage.token;
        }

        function redirectToLogin() {
            $location.path('/login');
        }

        function stateRedirector() {
            var auth = apiService.Auth();
            var request = auth.stateRedirector();
            return request.$promise;
        }

        function hasAccess(state) {
            var defer = $q.defer();
            if (!isAuthenticated()) {
                defer.reject({ redirectTo: 'app.login' });
            } else {
                var auth = apiService.Auth();
                var request = auth.hasAccess({ state: state });
                request.$promise.then(function(res) {
                    defer.resolve();
                });
                request.$promise.catch(function() {
                    defer.reject({ redirectTo: 'app.unauthorized' });
                });
            }
            return defer.promise;
        }
    }
})();

(function() {
  'use strict';

  angular.module('app.core').factory('apiResolver', apiResolverService);

  /** @ngInject */
  function apiResolverService($q, $log, api) {
    var service = {
      resolve: resolve
    };

    return service;

    //////////
    /**
     * Resolve api
     * @param action
     * @param parameters
     */
    function resolve(action, parameters) {
      var actionParts = action.split('@'),
        resource = actionParts[0],
        method = actionParts[1],
        params = parameters || {};

      if (!resource || !method) {
        $log.error(
          'apiResolver.resolve requires correct action parameter (ResourceName@methodName)'
        );
        return false;
      }

      // Create a new deferred object
      var deferred = $q.defer();

      // Get the correct api object from api service
      var apiObject = getApiObject(resource);

      if (!apiObject) {
        $log.error('Resource "' + resource + '" is not defined in the api service!');
        deferred.reject(
          'Resource "' + resource + '" is not defined in the api service!'
        );
      } else {
        apiObject[method](
          params,

          // Success
          function(response) {
            deferred.resolve(response);
          },

          // Error
          function(response) {
            deferred.reject(response);
          }
        );
      }

      // Return the promise
      return deferred.promise;
    }

    /**
     * Get correct api object
     *
     * @param resource
     * @returns {*}
     */
    function getApiObject(resource) {
      // Split the resource in case if we have a dot notated object
      var resourceParts = resource.split('.'),
        apiObject = api;

      // Loop through the resource parts and go all the way through
      // the api object and return the correct one
      for (var l = 0; l < resourceParts.length; l++) {
        if (angular.isUndefined(apiObject[resourceParts[l]])) {
          $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
          apiObject = false;
          break;
        }

        apiObject = apiObject[resourceParts[l]];
      }

      if (!apiObject) {
        return false;
      }

      return apiObject;
    }
  }
})();

(function() {
    angular.module('app.core').directive('viewPdf', function() {
        return {
            restrict: 'E',
            link: function(scope, element, attrs) {
                var url = scope.$eval(attrs.src);
                element.replaceWith(
                    '<object type="application/pdf" data="' + url + '"></object>'
                );
            }
        };
    });
})();

(function() {
    angular.module('app.core').directive('onErrorSrc', function() {
        return {
            link: function(scope, element, attrs) {
                element.bind('error', function() {
                    if (attrs.src != attrs.onErrorSrc) {
                        attrs.$set('src', attrs.onErrorSrc);
                    }
                });
            }
        };
    });
})();

(function() {
    angular.module('app.core').directive('lazyLoadMedia', lazyLoadMedia);

    function lazyLoadMedia() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                loader: '=',
                filename: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var spinner = 'assets/images/loader.svg';

            function setupImage() {
                element.attr('src', spinner);
                element.addClass('loading-images');
                scope.loader(scope.filename).then(function(url) {
                    element.attr('src', url);
                    element.removeClass('loading-images');
                    element.addClass('rendered-images');
                });
            }

            scope.$watch('filename', function(oldValue, newValue) {
                if (newValue) {
                    setupImage();
                }
            });
        }
    }
})();

(function() {
    angular.module('app.core').directive('imageonload', [
        '$timeout',
        function($timeout) {
            return {
                link: function($scope, element, attrs) {
                    function waitForImage(url) {
                        var tempImg = new Image();
                        tempImg.onload = function() {
                            $timeout(function() {
                                element.attr('src', url);
                            });
                        };
                        tempImg.onerror = function() {
                            $timeout(function() {
                                element.attr(
                                    'src',
                                    'assets/images/avatars/profile.jpg'
                                );
                            });
                        };
                        tempImg.src = url;
                    }

                    attrs.$observe('imageonload', function(newValue) {
                        if (newValue) {
                            waitForImage(newValue);
                        }
                    });
                }
            };
        }
    ]);
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
    'use strict';

    angular.module('app.toolbar').controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(
        $rootScope,
        $q,
        $state,
        $timeout,
        $mdSidenav,
        $translate,
        $mdToast,
        msNavigationService,
        authService,
        fuseTheming,
        $cookies,
        $scope,
        $localStorage
    ) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];
        vm.languages = {
            en: {
                title: 'English',
                translation: 'TOOLBAR.ENGLISH',
                code: 'en',
                flag: 'us'
            },
            id: {
                title: 'Bahasa',
                translation: 'TOOLBAR.BAHASA',
                code: 'id',
                flag: 'id'
            }
        };

        vm.userName = $localStorage.username;
        vm.groupName = $localStorage.group;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.theme = $cookies.get('selectedTheme') || fuseTheming.themes.active.name;

        $scope.$watch(
            function() {
                return $cookies.get('selectedTheme');
            },
            function(val) {
                vm.theme = val;
            }
        );

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            authService.logout();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            // if (lang.code !== 'en') {
            //     var message =
            //         'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

            //     $mdToast.show({
            //         template:
            //             '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' +
            //             message +
            //             '</div></md-toast>',
            //         hideDelay: 7000,
            //         position: 'top right',
            //         parent: '#content'
            //     });

            //     return;
            // }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function(item) {
                    if (
                        angular
                            .lowercase(item.title)
                            .search(angular.lowercase(query)) > -1
                    ) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function() {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, appConfig) {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        vm.appTitle = appConfig.appTitle;

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function() {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('assessmentapp', [
            'app.core',
            'textAngular',
            'app.navigation',
            'app.toolbar',
            'app.quick-panel',
            'app.sample',
            'app.login',
            'app.dashboard',
            'app.account',
            'app.qa',
            'app.clients',
            'app.enrollment',
            'app.report',
            'app.utility',
            'app.unauthorized'
        ])
        .config(config);

    function config() {}
})();

(function() {
    'use strict';

    angular.module('assessmentapp').controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function(event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.core').run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig) {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if (
            fuseConfig.getConfig('disableMdInkRippleOnMobile') &&
            msUtils.isMobile()
        ) {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if (msUtils.isMobile()) {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if (browserInfo) {
            var htmlClass =
                browserInfo.browser +
                ' ' +
                browserInfo.version +
                ' ' +
                browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config(
        $ariaProvider,
        $logProvider,
        msScrollConfigProvider,
        fuseConfigProvider
    ) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: true
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            disableCustomScrollbars: false,
            disableCustomScrollbarsOnMobile: true,
            disableMdInkRippleOnMobile: true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function() {
    'use strict';

    angular.module('assessmentapp').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function() {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on(
            '$stateChangeSuccess',
            function() {
                $timeout(function() {
                    $rootScope.loadingProgress = false;
                });
            }
        );

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function() {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function() {
    'use strict';

    angular.module('assessmentapp').config(routeConfig);

    /** @ngInject */
    function routeConfig(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider,
        $httpProvider
    ) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        $httpProvider.interceptors.push('AuthInterceptor');

        // Get active layout
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation:
                    'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar:
                    'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation:
                    'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main:
                    'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar:
                    'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation:
                    'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation:
                    'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'main@': {
                    templateUrl: layouts[layoutStyle].main,
                    controller: 'MainController as vm'
                },
                'toolbar@app': {
                    templateUrl: layouts[layoutStyle].toolbar,
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: layouts[layoutStyle].navigation,
                    controller: 'NavigationController as vm'
                },
                'quickPanel@app': {
                    templateUrl: 'app/quick-panel/quick-panel.html',
                    controller: 'QuickPanelController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular.module('assessmentapp').factory('AuthInterceptor', [
        '$q',
        '$injector',
        function($q, $injector) {
            var cachedRequest = null;
            return {
                request: function(config) {
                    // If request need credentials
                    if (angular.isDefined(config.withCredentials)) {
                        if (config.withCredentials) {
                            var accessToken = $injector
                                .get('authService')
                                .getToken();
                            config.headers['Authorization'] =
                                'Bearer ' + accessToken;
                        }
                    }
                    return config;
                },
                responseError: function(response) {
                    switch (response.status) {
                        //Detect if reponse error is 401 (Unauthorized)
                        case 401:
                            //Cache this request
                            var deferred = $q.defer();

                            // check if there is token in storage
                            var authenticated = $injector
                                .get('authService')
                                .isAuthenticated();

                            // if no token then redirect to login
                            if (!authenticated) {
                                deferred.reject({ message: 'Unauthorized' });
                                $injector.get('authService').redirectToLogin();
                            }

                            if (!cachedRequest) {
                                //Cache request for renewing Access Token and wait for Promise
                                cachedRequest = $injector
                                    .get('authService')
                                    .refreshToken();
                            }
                            //When Promise is resolved, new Access Token is returend
                            cachedRequest.then(function(accessToken) {
                                cachedRequest = null;
                                if (accessToken) {
                                    $injector
                                        .get('authService')
                                        .setToken(accessToken.data);
                                    //Resend this request when Access Token is renewed
                                    $injector
                                        .get('$http')(response.config)
                                        .then(
                                            function(resp) {
                                                //Resolve this request (successfully this time)
                                                deferred.resolve(resp);
                                            },
                                            function(resp) {
                                                deferred.reject({
                                                    message: 'Unauthorized'
                                                });
                                            }
                                        );
                                } else {
                                    //If any error occurs reject the Promise
                                    deferred.reject();
                                }
                            });
                            cachedRequest.catch(function(response) {
                                //If any error occurs reject the Promise
                                cachedRequest = null;
                                $injector.get('authService').redirectToLogin();
                                deferred.reject({ message: 'Unauthorized' });
                                return;
                            });
                            return deferred.promise;
                    }
                    //If any error occurs reject the Promise
                    return $q.reject(response);
                }
            };
        }
    ]);
})();

(function() {
    'use strict';

    angular.module('assessmentapp').controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(
        fuseTheming,
        msNavigationService,
        $scope,
        $localStorage,
        $q
    ) {
        var vm = this;

        fuseTheming.setActiveTheme('pinkTheme');

        vm.themes = fuseTheming.themes;

        initMenu();

        $scope.$on('MENU::LOADED', function() {
            initMenu();
        });

        $scope.$on('LOGIN::LOADED', function() {
            resetMenu();
        });

        function initMenu() {
            if (angular.isDefined($localStorage.menus)) {
                var menu = angular.copy($localStorage.menus);
                menu.map(function(val) {
                    setMenu(val);
                });
            }
        }

        function setMenu(params) {
            var options = {
                title: params.title,
                translate: params.translate,
                weight: params.weight,
                icon: params.icon,
                group: false
            };
            if (params.is_group == 0) {
                options.state = params.state;
            }
            msNavigationService.saveItem(params.name, options);
        }

        function resetMenu() {
            function deleteMenu() {
                var defer = $q.defer();
                if (angular.isDefined($localStorage.menus)) {
                    var menu = angular.copy($localStorage.menus);
                    menu.map(function(val) {
                        msNavigationService.deleteItem(val.name);
                    });
                    defer.resolve();
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            deleteMenu().then(function() {
                $localStorage.$reset();
            });
        }

        //////////
    }
})();

(function() {
    'use strict';

    angular.module('assessmentapp').constant('appConfig', {
        appTitle: 'OnlineTest',
        appName: 'Online Test',
        appDesc: 'Online Test Application',
        appVersion: '1.2',
        apiUrl: '/api/public/api/v2/',
        port: ''
    });
})();

(function() {
    'use strict';

    angular.module('assessmentapp').config(config);

    /** @ngInject */
    function config($translateProvider, blockUIConfig, $provide) {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'app/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        blockUIConfig.message = 'Please wait';
        blockUIConfig.delay = 300;
        blockUIConfig.autoBlock = false;

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate',
            function(taOptions) {
                taOptions.toolbar = [
                    [
                        'bold',
                        'italics',
                        'underline',
                        'ul',
                        'ol',
                        'quote',
                        'insertImage',
                        'justifyLeft',
                        'justifyCenter',
                        'justifyRight',
                        'indent',
                        'outdent',
                        'insertVideo'
                    ]
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate',
            function(taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }
})();

(function() {
    'use strict';

    angular.module('assessmentapp').factory('apiService', apiService);

    /** @ngInject */
    function apiService($resource, appConfig) {
        var service = {
            Auth: Auth,
            Menu: Menu,
            Account: Account,
            Competency: Competency,
            Pool: Pool,
            Category: Category,
            Reference: Reference,
            QuestionGeneral: QuestionGeneral,
            Assessment: Assessment,
            Classroom: Classroom,
            GroupParticipant: GroupParticipant,
            SessionGroup: SessionGroup,
            UserParticipant: UserParticipant,
            Guides: Guides,
            Report: Report,
            Dashboard: Dashboard
        };

        return service;

        // method
        function Auth() {
            return $resource(appConfig.apiUrl + 'auth/:action', null, {
                login: {
                    params: { action: 'login' },
                    method: 'POST',
                    withCredentials: false
                },
                refresh: {
                    params: { action: 'refresh' },
                    method: 'POST',
                    withCredentials: false
                },
                logout: {
                    params: { action: 'logout' },
                    method: 'POST',
                    withCredentials: false
                },
                hasAccess: {
                    params: { action: 'hasAccess' },
                    method: 'POST',
                    withCredentials: true
                },
                stateRedirector: {
                    params: { action: 'stateRedirect' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Menu() {
            return $resource(appConfig.apiUrl + 'menu/:action', null, {
                getMenu: {
                    params: { action: 'getMenu' },
                    method: 'GET',
                    withCredentials: true
                },
                view: {
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                getPermissionByState: {
                    params: { action: 'getPermissionByState' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                switchMenu: {
                    params: { action: 'switchMenu' },
                    method: 'POST',
                    withCredentials: true
                },
                switchAction: {
                    params: { action: 'switchAction' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Account() {
            return $resource(appConfig.apiUrl + 'account/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                },
                changePassword: {
                    params: { action: 'changePassword' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Competency() {
            return $resource(appConfig.apiUrl + 'competency/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Category() {
            return $resource(appConfig.apiUrl + 'question-category/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Guides() {
            return $resource(appConfig.apiUrl + 'guide/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                },
                loadGuide: {
                    params: { action: 'getGuide' },
                    method: 'GET',
                    responseType: 'blob',
                    transformResponse: function(data) {
                        // Stores the ArrayBuffer object in a property called "data"
                        return { data: data };
                    },
                    withCredentials: true
                },
                loadGuideById: {
                    cache: false,
                    params: { action: 'getGuideById' },
                    method: 'GET',
                    withCredentials: true
                }
            });
        }

        function Pool() {
            return $resource(appConfig.apiUrl + 'question-pool/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Classroom() {
            return $resource(appConfig.apiUrl + 'classroom/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function SessionGroup() {
            return $resource(appConfig.apiUrl + 'session/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                },
                getAvailableDate: {
                    cache: false,
                    params: { action: 'getAvailableDate' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                }
            });
        }

        function GroupParticipant() {
            return $resource(appConfig.apiUrl + 'group-participant/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function UserParticipant() {
            return $resource(appConfig.apiUrl + 'user-participant/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Assessment() {
            return $resource(appConfig.apiUrl + 'assessment/:action', null, {
                session: {
                    cache: false,
                    params: { action: 'session' },
                    method: 'GET',
                    withCredentials: true
                },
                question: {
                    cache: false,
                    params: { action: 'question' },
                    method: 'GET',
                    withCredentials: true
                },
                isGuideRead: {
                    cache: false,
                    params: { action: 'isGuideRead' },
                    method: 'GET',
                    withCredentials: true
                },
                sync: {
                    cache: false,
                    params: { action: 'synchronize' },
                    method: 'POST',
                    withCredentials: true
                },
                submit: {
                    cache: false,
                    params: { action: 'submit' },
                    method: 'POST',
                    withCredentials: true
                }
            });
        }

        function Reference() {
            return $resource(appConfig.apiUrl + 'reference/:action', null, {
                competency: {
                    cache: false,
                    params: { action: 'competency' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                competencyCategory: {
                    cache: false,
                    params: { action: 'competencyCategory' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                questionCategory: {
                    cache: false,
                    params: { action: 'questionCategory' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                questionPool: {
                    cache: false,
                    params: { action: 'questionPool' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                classroom: {
                    cache: false,
                    params: { action: 'classroom' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                groupParticipant: {
                    cache: false,
                    params: { action: 'groupParticipant' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                guides: {
                    cache: false,
                    params: { action: 'guides' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                users: {
                    cache: false,
                    params: { action: 'users' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                listGroupParticipant: {
                    cache: false,
                    params: { action: 'listGroupParticipant' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                subArea: {
                    cache: false,
                    params: { action: 'subArea' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                },
                company: {
                    cache: false,
                    params: { action: 'company' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true
                }
            });
        }

        function Report() {
            return $resource(appConfig.apiUrl + 'report/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                detail: {
                    cache: false,
                    params: { action: 'detail' },
                    method: 'GET',
                    withCredentials: true
                }
            });
        }

        function QuestionGeneral() {
            return $resource(appConfig.apiUrl + 'question-general/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true
                },
                upload: {
                    params: { action: 'upload' },
                    method: 'POST',
                    withCredentials: true,
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                },
                images: {
                    params: { action: 'getQuestionImage' },
                    method: 'GET',
                    responseType: 'blob',
                    transformResponse: function(data) {
                        // Stores the ArrayBuffer object in a property called "data"
                        return { data: data };
                    }
                }
            });
        }

        function Dashboard() {
            return $resource(appConfig.apiUrl + 'dashboard/:action', null, {
                loadWidget: {
                    cache: false,
                    params: { action: 'loadWidget' },
                    method: 'GET',
                    withCredentials: true
                },
                loadLatestSubmit: {
                    cache: false,
                    params: { action: 'loadLatestSubmit' },
                    method: 'GET',
                    withCredentials: true
                },
                getQuestionStats: {
                    cache: false,
                    params: { action: 'getQuestionStats' },
                    method: 'GET',
                    withCredentials: true
                },
                getChartUserStats: {
                    cache: false,
                    params: { action: 'getChartUserStats' },
                    method: 'GET',
                    withCredentials: true
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.utility', ['app.utility.menu']).config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

(function() {
    'use strict';

    angular
        .module('app.qa', [
            'app.qa.pool',
            'app.qa.category',
            'app.qa.guides',
            'app.qa.questions_general'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

(function() {
    'use strict';

    angular
        .module('app.enrollment', ['app.enrollment.session_group'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

angular.module("assessmentapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div>\n<md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\">\n<md-radio-button ng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div \nclass=\"option-title\">Color Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/templates/pagination.html","<div class=\"pagination-container\" layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" flex><div \nclass=\"pagination-label\">Displaying {{ range.lower }} - {{ range.upper }} of {{ range.total }}</div><ul \nclass=\"pagination-custom\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == 1 }\"><a class=\"is-dark-bg\" href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a>\n</li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li \nng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" \nng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pagination.last)\">&raquo;</a></li></ul></div>");
$templateCache.put("app/main/account/account.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.ACCOUNT.TITLE\">Accounts</div><div \ntranslate=\"PAGE.ACCOUNT.SUB_TITLE\" class=\"sub-title\">This is accounts page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Company</label><md-select ng-model=\"vm.selectedCompany\" \nclass=\"md-accent md-hue-1\" ng-change=\"vm.onCompanyChange()\" name=\"company\"><md-option \nng-repeat=\"val in vm.listCompany\" ng-value=\"val\">{{val | uppercase}}</md-option></md-select></md-input-container>\n<md-input-container flex class=\"wrapper-input\"><label>Sub Area</label><md-select ng-model=\"vm.selectedSubArea\" \nclass=\"md-accent md-hue-1\" name=\"sub_area\"><md-option ng-selected=\"vm.selectedSubArea == val.id\" \nng-repeat=\"val in vm.listSubArea\" ng-value=\"val.id\">{{val.description}}</md-option></md-select></md-input-container>\n</div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" class=\"container\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" ms-responsive-table><thead><tr \nclass=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th class=\"text-center\">NIK</th><th \nclass=\"text-start\">NAME</th><th class=\"text-center\">GROUP</th><th class=\"text-center\">COMPANY</th><th \nclass=\"text-center\">AREA</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead>\n<tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + ($index)}}</td><td \nclass=\"text-center\">{{val.nik}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-center\">\n{{val.roles.group.name}}</td><td class=\"text-center\">{{val.user_subarea.sub_area.company_id}}</td><td \nclass=\"text-center\">{{val.user_subarea.sub_area.description}}</td><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center\"><md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"4\"><md-menu-item><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>Edit</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"change password\" ng-if=\"vm.actionPermit.changePassword\" ng-click=\"vm.changePassword($event, val)\" \nclass=\"md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-key\"></md-icon>Change Password</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button aria-label=\"delete\" \nng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\"><div layout-gt-sm=\"row\" class=\"header\" layout=\"column\" flex layout-align=\"start center\"><md-button \nng-click=\"vm.reloadData()\" class=\"md-icon-button md-accent\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<div class=\"md-title\">Last Updated : {{vm.date}}</div><div flex></div><div flex layout=\"row\"><md-input-container flex>\n<label>Company</label><md-select ng-model=\"vm.selectedCompany\" ng-change=\"vm.onCompanyChange()\" name=\"company\">\n<md-option ng-repeat=\"val in vm.listCompany\" ng-value=\"val\">{{val | uppercase}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Sub Area</label><md-select ng-model=\"vm.selectedSubArea\" \nname=\"sub_area\"><md-option ng-selected=\"vm.selectedSubArea == val.id\" ng-repeat=\"val in vm.listSubArea\" \nng-value=\"val.id\">{{val.description}}</md-option></md-select></md-input-container></div></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-account-multiple\"></md-icon><div class=\"h3\">Total Active User</div></div></div><div \nng-show=\"vm.isLoading.widget\" layout=\"row\" layout-align=\"center center\" flex><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"!vm.isLoading.widget\" class=\"pb-24\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"h2\">{{vm.widget.total_user_online}}</div><div class=\"h2 pl-8 secondary-text\">\n/ {{vm.widget.total_user}}</div></div><div ng-show=\"!vm.isLoading.widget\" layout=\"row\" layout-align=\"start center\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget.percentage_total_user_online}}\"></md-progress-linear><div \nclass=\"margin-left-10 w-50\">{{vm.widget.percentage_total_user_online}} %</div></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 deep-orange-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-account-network\"></md-icon><div \nclass=\"h3\">Initialize Test</div></div></div><div ng-show=\"vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"!vm.isLoading.widget\" class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">\n{{vm.widget.today_in_init}}</div><div class=\"h2 pl-8 secondary-text\">/ {{vm.widget.total_user_test}}</div></div><div \nng-show=\"!vm.isLoading.widget\" layout=\"row\" layout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget.percentage_in_init}}\"></md-progress-linear><div class=\"margin-left-10 w-50\">\n{{vm.widget.percentage_in_init}} %</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 indigo-bg white-fg\"><div \nclass=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-chart-line\"></md-icon><div class=\"h3\">In Progress</div></div></div><div \nng-show=\"vm.isLoading.widget\" layout=\"row\" layout-align=\"center center\" flex><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"!vm.isLoading.widget\" class=\"pb-24\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"h2\">{{vm.widget.today_in_progress}}</div><div class=\"h2 pl-8 secondary-text\">\n/ {{vm.widget.total_user_test}}</div></div><div ng-show=\"!vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget.percentage_in_progress}}\">\n</md-progress-linear><div class=\"margin-left-10 w-50\">{{vm.widget.percentage_in_progress}} %</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-checkbox-marked-circle\">\n</md-icon><div class=\"h3\">Finished</div></div></div><div ng-show=\"vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nclass=\"pb-24\" ng-show=\"!vm.isLoading.widget\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">\n{{vm.widget.today_finished}}</div><div class=\"h2 pl-8 secondary-text\">/ {{vm.widget.total_user_test}}</div></div><div \nng-show=\"!vm.isLoading.widget\" layout=\"row\" layout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget.percentage_finished}}\"></md-progress-linear><div class=\"margin-left-10 w-50\">\n{{vm.widget.percentage_finished}} %</div></div></ms-widget-front></ms-widget></div><div class=\"table-container\" \nlayout=\"row\" block-ui=\"block-latest-submit\"><div class=\"simple-table-container md-whiteframe-4dp\"><div \nclass=\"table-title\"><div layout=\"row\" layout-align=\"space-between center\"><div>Latest Submit</div><div><form ng-clock \nng-submit=\"vm.paginationSubmit.load(1)\"><input class=\"input-search\" placeholder=\"search\" type=\"text\" \nng-model=\"vm.paginationSubmit.search\"></form></div></div></div><table class=\"app-table condensed\" ms-responsive-table>\n<thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th class=\"text-start\">NIK</th><th \nclass=\"text-start\">NAME</th><th class=\"text-center\">FINISHED AT</th><th class=\"text-right\">CORRECT</th><th \nclass=\"text-right\">INCORRECT</th><th class=\"text-right\">SCORE</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" \nclass=\"text-center\">ACTION</th></tr></thead><tbody><tr \ndir-paginate=\"val in vm.paginationSubmit.data | itemsPerPage: vm.paginationSubmit.page_size\" \ntotal-items=\"vm.paginationSubmit.total\" current-page=\"vm.paginationSubmit.current\"><td class=\"text-center w-50\">\n{{vm.paginationSubmit.from + $index}}</td><td class=\"text-start\">{{val.user.nik}}</td><td class=\"text-start\">\n{{val.user.name}}</td><td class=\"text-center\">{{val.created_at}}</td><td class=\"text-right\">{{val.correct_answer}}</td>\n<td class=\"text-right\">{{val.wrong_answer}}</td><td class=\"text-right\">{{val.score}}</td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" ng-click=\"vm.goToDetail(val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></div><div \nclass=\"chart-container padding-15\" block-ui=\"block-chart\"><md-content><canvas id=\"base\" class=\"chart-horizontal-bar\" \nchart-data=\"vm.userStats.data\" chart-options=\"vm.chartOptions\" chart-colors=\"[\'md-accent\']\" \nchart-series=\"vm.userStats.series\" chart-labels=\"vm.userStats.labels\"></canvas></md-content></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex layout-align=\"space-between start\" class=\"list-container padding-15\"><div flex-gt-sm=\"50\" \nflex=\"100\"><md-content><md-toolbar layout=\"row\" class=\"red-400-bg md-hue-1\"><div class=\"md-toolbar-tools\"><span>\nTop 10 questions that are answered incorrectly the most</span></div></md-toolbar><md-list flex \nblock-ui=\"block-most-question\"><md-list-item class=\"md-2-line\" ng-repeat-start=\"item in vm.questionStats.incorrect\" \nng-click=\"vm.showDialog($event, \'INCORRECT\', item.user_incorrect)\"><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-30 md-raised md-accent\">{{$index + 1}}\n</md-button><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.question.question }}</h3><p>\n{{ item.question_category.name }}</p></div><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-30 md-raised md-accent\">\n{{item.total_user_incorrect}}</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content>\n</div><md-divider show hide-gt-sm></md-divider><div class=\"w-10\" hide show-gt-sm></div><div flex-gt-sm=\"50\" flex=\"100\">\n<md-content><md-toolbar layout=\"row\" class=\"teal-400-bg md-hue-1\"><div class=\"md-toolbar-tools\"><span>\nTop 10 questions that are answered correctly the most</span></div></md-toolbar><md-list flex \nblock-ui=\"block-most-question\"><md-list-item class=\"md-2-line\" ng-repeat-start=\"item in vm.questionStats.correct\" \nng-click=\"vm.showDialog($event, \'CORRECT\', item.user_correct)\"><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-30 md-raised md-accent\">{{$index + 1}}\n</md-button><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.question.question }}</h3><p>\n{{ item.question_category.name }}</p></div><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-30 md-raised md-accent\">\n{{item.total_user_correct}}</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content>\n</div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" block-ui=\"loginForm\" layout=\"row\" class=\"md-accent-bg md-hue-2\" layout-align=\"end center\"><div \nid=\"login-intro\" hide show-gt-sm><div class=\"title\">Hi welcome to online test !</div></div><div \nid=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div class=\"logo\"><img\n src=\"assets/images/logos/logo.png\" alt=\"\"></div><div class=\"title red-900-fg\">{{vm.config.appName}}</div><div \nclass=\"description black-500-fg text-italic\"><span class=\"desc-title\">Masuk Sebagai</span> <span \nclass=\"desc-sub fade-element-in\" \nng-class=\"{\'green-400-fg\': vm.authType === \'employee\', \'amber-500-fg\': vm.authType === \'guest\'}\" ng-if=\"vm.isPushed\">\n{{vm.authType}}</span></div><div layout=\"row\" flex class=\"cta-container fade-element-in\" ng-if=\"!vm.isPushed\" \nlayout-align=\"space-around center\"><button ng-click=\"vm.isPushed = !vm.isPushed; vm.authType = \'employee\'\" \nclass=\"btn-custom\"><div layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-account s50\">\n</md-icon><div>Karyawan</div></div></button> <button ng-click=\"vm.isPushed = !vm.isPushed; vm.authType = \'guest\'\" \nclass=\"btn-custom\"><div layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-account s50\">\n</md-icon><div>Pelamar</div></div></button></div><div ng-if=\"vm.isPushed\" class=\"cta-container fade-element-in\" \nlayout=\"row\" flex><md-button ng-click=\"vm.isPushed = false\" type=\"submit\" class=\"md-accent\" aria-label=\"LOG IN\">\n&#8592; Back</md-button></div><form name=\"loginForm\" ng-if=\"vm.isPushed\" novalidate class=\"fade-element-in\" \nng-submit=\"vm.login()\"><md-input-container class=\"md-block\"><label>Username</label><input type=\"text\" name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"Username\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Password</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-primary submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">LOG IN</md-button></form><div class=\"separator\"></div></div>\n</div></div>");
$templateCache.put("app/main/report/report.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.REPORT.TITLE\">Report</div><div translate=\"PAGE.REPORT.SUB_TITLE\" \nclass=\"sub-title\">This is question report page</div></div><div flex></div><div class=\"header-toolbox\"><md-button \nclass=\"md-icon-button md-primary md-hue-3\"><md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip>\n<span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span></md-tooltip></md-button></div></div><md-toolbar layout=\"row\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25]\" ng-value=\"val\">{{val}}\n</md-option></md-select></md-input-container><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"export\" ng-click=\"vm.exportData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-file-excel-box\"></md-icon></md-button><md-button ng-click=\"vm.showFilter = !vm.showFilter\" \naria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"start_date\" \nng-model=\"vm.tempStart\" class=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\">\n<label>End Date</label><input type=\"date\" name=\"end_date\" ng-model=\"vm.tempEnd\" class=\"md-accent md-hue-1\">\n</md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th \nclass=\"text-start\">NIK</th><th class=\"text-start\">NAME</th><th class=\"text-start\">GROUP</th><th class=\"text-center\">\nFINISHED AT</th><th class=\"text-center\">QUESTION TOTAL</th><th class=\"text-right\">SCORE (AVG BY % CATEGORY)</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.user.nik}}</td><td class=\"text-start\">{{val.user.name | uppercase }}</td><td \nclass=\"text-start\">{{val.session.group_participant.name}}</td><td class=\"text-center\">{{val.created_at}}</td><td \nclass=\"text-center\">{{val.question_total}}</td><td class=\"text-right\">{{ val.avg_category | number:2 }} %</td><td \nclass=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button aria-label=\"view\" ng-click=\"vm.goToDetail(val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/clients/clients.html","<div id=\"clients-layout\" class=\"page-layout\" layout=\"column\"><div \nclass=\"header md-accent-bg md-hue-2 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\">Online Test</div><div class=\"sub-title\">Welcome to Online Test</div></div><div \nflex></div><div class=\"header-toolbox\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.logout()\"><md-icon \nmd-font-icon=\"icon-exit-to-app\"></md-icon>Keluar</md-button></div></div><div class=\"content animate-slide-right\" \nui-view=\"client_content\"></div></div>");
$templateCache.put("app/main/unauthorized/unauthorized.html","<div class=\"page-layout simple fullwidth\"><div layout=\"column\" layout-align=\"center center\" class=\"unauthorized\">\n<md-icon class=\"md-warn-fg s50\" md-font-icon=\"icon-block-helper\"></md-icon><div class=\"h1 margin-top-15 md-warn-fg\">\nUnauthorized</div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgba(0,0,0,0.6)\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular \nclass=\"md-accent\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div></label><input \nid=\"ms-search-bar-input\" type=\"text\" placeholder=\"Search\" flex ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.blurred()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" \nms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-primary md-hue-1 md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image md-accent-bg md-hue-2\">R</span> <span class=\"logo-text\">Online Test</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/main/report/view-detail/view-detail.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\">Detail Report {{vm.data.achievement.user.name | titleCase}}</div><div \nlayout=\"row\" class=\"sub-title\"><div class=\"achievement\">submitted at : {{vm.data.achievement.created_at}}</div></div>\n</div><div flex></div><div class=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button aria-label=\"back\" ng-click=\"vm.backToReport()\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n</div></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nGroup Participant</label><md-select ng-model=\"vm.groupParticipant\" class=\"md-accent md-hue-1\" name=\"groupParticipant\">\n<md-option ng-selected=\"vm.groupParticipant == val.id\" ng-repeat=\"val in vm.listGroupParticipant\" ng-value=\"val.id\">\n{{val.description}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container\n flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"start_date\" ng-model=\"vm.tempStart\" \nclass=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\"><label>End Date</label>\n<input type=\"date\" name=\"end_date\" ng-model=\"vm.tempEnd\" class=\"md-accent md-hue-1\"></md-input-container></div>\n</md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" class=\"container\"><div \nclass=\"simple-table-container md-whiteframe-4dp report-detail-table\"><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"table-title\"><md-button class=\"md-raised white-fg indigo-400-bg\" flex>\nQUESTION TOTAL : {{vm.data.achievement.question_total}}</md-button><md-button \nng-click=\"vm.filter.valid = !vm.filter.valid\" class=\"md-raised white-fg green-400-bg\" \nng-class=\"{\'black-bg\' : vm.filter.valid}\" flex>CORRECT : {{vm.data.achievement.correct_answer}}</md-button><md-button \nng-click=\"vm.filter.invalid = !vm.filter.invalid\" class=\"md-raised white-fg red-400-bg\" \nng-class=\"{\'black-bg\' : vm.filter.invalid}\" flex>INCORRECT : {{vm.data.achievement.wrong_answer}}</md-button><md-button\n ng-click=\"vm.filter.not_answered = !vm.filter.not_answered\" class=\"md-raised white-fg blue-grey-400-bg\" \nng-class=\"{\'black-bg\' : vm.filter.not_answered}\" flex>NOT ANSWERED : {{vm.data.achievement.not_answered}}</md-button>\n</div><table class=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th \nclass=\"text-center w-50\">NO</th><th class=\"text-start\">QUESTION</th><th class=\"text-start\">SERVER ANSWER</th><th \nclass=\"text-start\">USER ANSWER</th><th class=\"text-start\">FLAG</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr ng-repeat=\"val in vm.data.detail | filter : vm.filteredFlag\"><td \nclass=\"text-center w-50\">{{$index + 1}}</td><td class=\"text-start\" style=\"max-width: 400px\">\n{{val.question_answers.question}}</td><td class=\"text-start\"><ul style=\"list-style: none; padding-inline-start: 5px\">\n<li ng-repeat=\"answer in val.answers\" ng-if=\"answer.source == \'USER\'\"><span class=\"badge md-accent-bg\">\n{{answer.abjact}}</span> <span class=\"margin-right-5\">.</span> {{ answer.answer_name}}</li></ul></td><td \nclass=\"text-start\"><ul style=\"list-style: none; padding-inline-start: 5px\"><li ng-repeat=\"answer in val.answers\" \nng-if=\"answer.source == \'SERVER\'\"><span class=\"badge md-accent-bg\">{{answer.abjact}}</span> <span \nclass=\"margin-right-5\">.</span> {{ answer.answer_name}}</li></ul></td><td class=\"text-start\"><md-icon \nmd-font-icon=\"{{vm.renderIconFlag(val.flag)}}\"></md-icon></td></tr></tbody></table></div></md-content></div></div>");
$templateCache.put("app/main/qa/pool/pool.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.POOL.TITLE\">Questions Pool</div><div \ntranslate=\"PAGE.POOL.SUB_TITLE\" class=\"sub-title\">This is question pool page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nCompany</label><md-select ng-model=\"vm.selectedCompany\" class=\"md-accent md-hue-1\" ng-change=\"vm.onCompanyChange()\" \nname=\"company\"><md-option ng-repeat=\"val in vm.listCompany\" ng-value=\"val\">{{val | uppercase}}</md-option></md-select>\n</md-input-container><md-input-container flex class=\"wrapper-input\"><label>Sub Area</label><md-select \nng-model=\"vm.selectedSubArea\" class=\"md-accent md-hue-1\" name=\"sub_area\"><md-option \nng-selected=\"vm.selectedSubArea == val.id\" ng-repeat=\"val in vm.listSubArea\" ng-value=\"val.id\">{{val.description}}\n</md-option></md-select></md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll>\n<md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">NAME</th><th class=\"text-start\">DESCRIPTION</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.description}}</td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/category/category.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.CATEGORY.TITLE\">Category</div><div \ntranslate=\"PAGE.CATEGORY.SUB_TITLE\" class=\"sub-title\">This is category page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-click=\"vm.loadData(1)\" ng-if=\"vm.actionPermit.view\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-center w-50\">ID</th><th class=\"text-start\">NAME</th><th class=\"text-start\">CODE</th><th \nclass=\"text-start\">DESCRIPTION</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr>\n</thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.code}}</td><td \nclass=\"text-start\">{{val.description}}</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button \naria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/account/change-password/change-password.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Account</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Password</label><input name=\"password\" type=\"password\" placeholder=\"password\" required \nng-model=\"vm.data.password\"><div ng-messages=\"frmRequest.password.$error\"><div ng-message=\"required\">This is required!\n</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>Password Confirmation</label><input \nname=\"password_confirmation\" type=\"password\" placeholder=\"Password Confirmation\" required \nng-model=\"vm.data.password_confirmation\"><div ng-messages=\"frmRequest.password_confirmation.$error\"><div \nng-message=\"required\">This is required!</div><div ng-message=\"isNotMatch\">Password Confirmation Not Match !</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CHANGE PASSWORD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dashboard/view-user/view-user.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" md-theme=\"{{vm.theme}}\"><md-toolbar class=\"md-accent-bg\"><div \nclass=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">{{vm.dialogType | titleCase }} User Answered List\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex>\n<md-content><md-list flex><md-list-item class=\"md-2-line\" \ndir-paginate-start=\"item in vm.filtered | itemsPerPage: vm.numPerPage\" total-items=\"vm.totalItems\" \ncurrent-page=\"vm.currentPage\" ng-click=\"null\"><div class=\"h2 margin-right-10\">{{vm.end + ($index + 1)}}</div><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ item.achievement.user.name }}</h3><p>{{ item.achievement.user.nik }}\n</p></div></md-list-item><md-divider dir-paginate-end></md-divider></md-list></md-content><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls template-url=\"app/core/templates/pagination.html\" \non-page-change=\"vm.pageChanged(newPageNumber)\"></dir-pagination-controls></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/qa/qa-general/qa-general.html","<div id=\"app-layout\" class=\"page-layout qa-general-component\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.QUESTION_GENERAL.TITLE\">General Question</div><div \ntranslate=\"PAGE.QUESTION_GENERAL.SUB_TITLE\" class=\"sub-title\">This is general question page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" ng-init=\"vm.showFilter = false\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button aria-label=\"upload\" ng-if=\"vm.actionPermit.upload\" ng-click=\"vm.uploadDialog($event)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" ng-if=\"vm.actionPermit.view\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nCategory</label><md-select ng-model=\"vm.questionCategory\" class=\"md-accent md-hue-1\" name=\"category\"><md-option \nng-selected=\"vm.questionCategory == val.id\" ng-repeat=\"val in vm.listQuestionCategory\" ng-value=\"val.id\">\n{{val.description}}</md-option></md-select></md-input-container><md-input-container flex class=\"wrapper-input\"><label>\nQuestion Pool</label><md-select ng-model=\"vm.questionPool\" class=\"md-accent md-hue-1\" name=\"category\"><md-option \nng-selected=\"vm.questionPool == val.id\" ng-repeat=\"val in vm.listQuestionPool\" ng-value=\"val.id\">{{val.description}}\n</md-option></md-select></md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll>\n<md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">CODE</th><th class=\"text-start\">QUESTION</th><th class=\"text-center\">IMAGES</th><th \nclass=\"text-center\">ANSWERS</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead>\n<tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"6\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr class=\"clickable\" ng-init=\"val.collapse = false\" \nng-click=\"val.collapse = !val.collapse\" \ndir-paginate-start=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" \ntotal-items=\"vm.pagination.total\" current-page=\"vm.pagination.current\"><td class=\"text-center w-50\">\n{{vm.pagination.from + $index}}</td><td class=\"text-start\">{{val.code}}</td><td class=\"text-start\"><span \nng-bind-html=\"vm.getQuestion(val.question.question)\"></span></td><td class=\"text-center\"><md-icon \nmd-font-icon=\"icon-check\" class=\"md-accent md-hue-1\" ng-if=\"val.question.having_images == 1\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" class=\"md-warn md-hue-1\" ng-if=\"val.question.having_images == 0\"></md-icon></td><td \nclass=\"text-center\"><div layout=\"row\"><md-button ng-repeat=\"answer in val.answers\" \nclass=\"md-icon-button white-fg md-raised small-8\" \nng-class=\"{\'green-400-bg\' : answer.flag == 1, \'amber-900-bg\': answer.flag == 0}\">{{answer.abjact}}<md-tooltip>\n{{answer.answer || \'-\' }}</md-tooltip></md-button></div></td><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr><tr class=\"darken-white-10\" dir-paginate-end \nng-if=\"val.collapse\"><td colspan=\"6\"><div flex=\"100\" layout=\"row\" layout-fill layout-align=\"center start\" \nclass=\"container-detail p-10 animate-slide-down\"><div layout=\"column\" class=\"img-container\"><img \nng-init=\"vm.getQuestionImages(val.question.images, val)\" imageonload=\"{{val.question_image}}\" \nsrc=\"assets/images/loader.svg\"></div><div flex layout=\"column\"><div layout=\"row\"><div class=\"w-100\">Category</div><div \nclass=\"w-10\">:</div><div>{{val.question_category.name}}</div></div><div layout=\"row\"><div class=\"w-100\">Answers</div>\n<div class=\"w-10\">:</div><div><ul class=\"list-answer\"><li ng-repeat=\"ans in val.answers\"><span \nng-class=\"{\'green-400-fg\' : ans.flag == 1, \'red-400-fg\': ans.flag == 0}\" class=\"margin-right-5\">{{ans.abjact}}</span> \n<span>{{ans.answer}}</span></li></ul></div></div></div></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/account/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Account</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-accent\" flex><label>Username / NIK</label><input name=\"nik\" type=\"text\" \nplaceholder=\"ex: 190xxxx\" required ng-model=\"vm.data.nik\"><div ng-messages=\"frmRequest.nik.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Name</label><input name=\"name\" type=\"text\" placeholder=\"ex: John Doe\" required ng-model=\"vm.data.name\"><div \nng-messages=\"frmRequest.name.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n<md-input-container class=\"md-accent\" flex><label>Group</label><md-select name=\"group\" required placeholder=\"group\" \nng-model=\"vm.data.group\"><md-option ng-value=\"val.id\" ng-selected=\"vm.data.group == val.id\" \nng-repeat=\"val in vm.listGroup\">{{val.name}}</md-option></md-select><div ng-messages=\"frmRequest.group.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"column\" \nng-if=\"vm.dialogType === \'CREATE\'\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>Password\n</label><input name=\"password\" type=\"password\" placeholder=\"password\" required ng-model=\"vm.data.password\"><div \nng-messages=\"frmRequest.password.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n<md-input-container class=\"md-accent\" flex><label>Password Confirmation</label><input name=\"password_confirmation\" \ntype=\"password\" placeholder=\"Password Confirmation\" required ng-model=\"vm.data.password_confirmation\"><div \nng-messages=\"frmRequest.password_confirmation.$error\"><div ng-message=\"required\">This is required!</div><div \nng-message=\"isNotMatch\">Password Confirmation Not Match !</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/assessment-general/assessment-general.html","<div class=\"container\"><guide-assessment ng-if=\"!vm.isGuideFinish\" on-click-start=\"vm.start($event)\" \nguide-id=\"vm.params.guide_id\" session-id=\"vm.params.session_id\"></guide-assessment><toolbar-assessment \nng-if=\"vm.isGuideFinish && vm.scheme.is_valid\" scheme=\"vm.scheme\" questions=\"vm.scheme.questions\" \nactive-question=\"vm.activeQuestion\" question-index=\"vm.questionIndex\" remaining-times=\"vm.scheme.remaining_times\" \ntheme=\"vm.themes\"></toolbar-assessment><div layout=\"column\" ng-if=\"vm.timeIsOver\" class=\"padding-15\"><div \nclass=\"h2 text-center\">Waktu pengerjaan telah berakhir silahkan klik <span class=\"md-warn-fg\">FINISH</span>\n untuk mengakhiri test</div></div><div ng-if=\"vm.isGuideFinish && !vm.timeIsOver\" ng-init=\"vm.showNav = true\" \nlayout=\"column\" layout-align=\"space-between\" id=\"general-container\" class=\"md-whiteframe-10dp\"><div \nclass=\"collapsable-nav\" ng-if=\"vm.scheme.is_valid\"><md-button ng-click=\"vm.showNav = !vm.showNav\" \nclass=\"md-icon-button md-raised md-primary\"><md-icon ng-class=\"{\'turn-down\' : !vm.showNav}\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></md-button></div><div layout=\"row\" ng-if=\"vm.scheme.is_valid\" \nng-show=\"vm.showNav\" layout-wrap class=\"navigation\"><button ng-disabled=\"vm.timeIsOver\" \nng-class=\"{\'empty\' : item.id !== vm.activeQuestion.id, \'active\' : item.id === vm.activeQuestion.id, \'submitted\' : item.is_submitted}\" \nng-click=\"vm.setQuestion($index)\" ng-repeat=\"item in vm.scheme.questions\" class=\"nav-item white-fg\">{{$index + 1}}\n</button></div><div layout=\"column\" ng-if=\"vm.scheme.is_valid\"><div class=\"question-wrapper\" layout=\"row\"><span \nclass=\"question\" ng-bind-html=\"vm.activeQuestion.question\"></span></div><div layout=\"column\" class=\"question-media\" \nlayout-align=\"center\" ng-if=\"vm.activeQuestion.having_images == 1\"><img class=\"img-container\" \nsrc=\"assets/images/loader.svg\" filename=\"vm.activeQuestion.images\" loader=\"vm.getQuestionImages\" lazy-load-media></div>\n<div class=\"answer-wrapper\" flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"item in vm.activeQuestion.answers\"><div ng-class=\"{\'md-accent-bg\': item.checked}\" \nclass=\"abjact md-primary-bg\">{{item.abjact}}</div><md-checkbox ng-disabled=\"vm.timeIsOver\" \nng-change=\"vm.onAnswerChange()\" ng-model=\"item.checked\" class=\"md-accent\">{{item.answer}}</md-checkbox></div></div>\n</div><div layout=\"row\" ng-if=\"vm.scheme.is_valid\" layout-align=\"center\" class=\"navigation-bottom\"><md-button \nng-click=\"vm.prevQuestion()\" ng-if=\"!vm.isFirstQuestion\" class=\"md-accent md-raised md-hue-2\">Sebelumnya</md-button>\n<md-button md-autofocus ng-if=\"!vm.isLastQuestion\" ng-click=\"vm.nextQuestion()\" class=\"md-accent md-raised md-hue-2\">\nSelanjutnya</md-button></div><div layout=\"column\" ng-if=\"!vm.scheme.is_valid\" class=\"padding-15\"><div \nclass=\"h3 margin-bottom-10\">Sesi telah kadaluarsa</div><div class=\"h4 margin-bottom-10\">\nSesi anda dimulai pukul : {{vm.scheme.validation.taken_time}} dan telah berakhir pada {{vm.scheme.validation.lead_time.text}}\n</div><div class=\"h4 margin-bottom-10\">\nAnda akan segera di alihkan ke halaman utama dalam {{vm.countdownExp}} atau anda dapat klik tombol dibawah ini untuk menuju ke halaman menu\n</div><md-button ng-click=\"vm.goToMenu()\" class=\"md-warn md-raised\">Klik disini untuk kembali ke halaman menu\n</md-button></div></div></div>");
$templateCache.put("app/main/clients/guides/guides.directive.html","<div layout=\"column\" class=\"guide-wrapper\"><div layout=\"column\" ng-if=\"vm.isErrorLoad\"><div class=\"h3 text-boxed\">\nGuide Not Found</div><md-button ng-click=\"vm.getGuide()\" class=\"md-accent\">RELOAD</md-button></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.isLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div layout=\"column\" class=\"guide-header\" ng-if=\"!vm.isErrorLoad && !vm.isLoading\"><div \nclass=\"h2\">{{vm.title}}</div></div><div class=\"guide-content md-whiteframe-10dp md-background md-hue-2\" \nng-if=\"!vm.isErrorLoad && !vm.isLoading && !vm.media\" layout=\"row\"><div class=\"p-20\" ng-bind-html=\"vm.description\">\n</div></div><div layout=\"row\" ng-if=\"!vm.isErrorLoad && !vm.isLoading\" class=\"guide-footer\"><div flex></div><md-button \nflex ng-click=\"vm.onClickStart()\" class=\"md-raised md-accent\">MULAI TEST</md-button><div flex></div></div></div>");
$templateCache.put("app/main/clients/toolbar/toolbar.directive.html","<md-toolbar id=\"toolbar-assessment\" layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" flex \nlayout-align=\"space-between center\"><div flex class=\"h2 badge-info\">\n{{vm.questionIndex + 1}} from {{vm.questions.length}}</div><div class=\"h2\">{{vm.fmtMSS(vm.remainingTimes)}}</div>\n<md-button aria-label=\"reload\" ng-click=\"vm.submit($event)\" ng-class=\"{\'green-400-bg\' : vm.remainingTimes <= 0}\" \nclass=\"md-raised md-accent md-hue-2 small-8\">Finish</md-button></div></div></md-toolbar>");
$templateCache.put("app/main/clients/menus/menus.html","<md-content layout=\"column\" class=\"container\" id=\"client-menus\" block-ui=\"block-content\"><div layout=\"row\" \nclass=\"card-wrapper\" ng-if=\"vm.listSession.length > 0\"><div flex-gt-sm=\"33\" flex-xs=\"100\" \nclass=\"app-card md-whiteframe-5dp\" ng-repeat=\"item in vm.listSession\"><div class=\"app-card-content-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"app-card-header text-center md-accent-bg\"><div \nclass=\"md-title\">PSIKOTEST</div></div><div class=\"app-card-content\"><div class=\"md-subhead\">\n{{ item.group_name | titleCase }}</div><div>{{item.session_start_date}} s.d {{item.session_start_date}}<br>\n{{item.session_start_time}} s.d {{item.session_end_time}}</div></div><md-button ng-disabled=\"item.disabled\" \nng-click=\"vm.launchTest(item)\" class=\"md-primary md-raised md-hue-2\">{{item.note}}</md-button></div></div></div><div \nlayout=\"row\" flex class=\"no-session\" layout-align=\"center center\" layout-fill ng-if=\"vm.listSession.length === 0\"><div \nflex layout=\"row\" class=\"app-card md-whiteframe-5dp\"><div class=\"app-card-content-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"app-card-content\"><span class=\"h3\">Anda tidak memiliki sesi test</span></div>\n<md-button layout=\"row\" ng-click=\"vm.loadSession()\" class=\"md-primary md-raised md-hue-2\"><div>Muat Ulang</div>\n<md-progress-circular ng-if=\"vm.isLoading\" class=\"margin-left-10 md-warn\" md-diameter=\"20\"></md-progress-circular>\n</md-button></div></div></div></md-content>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/main/enrollment/session-group/session-group.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.SESSION_GROUP.TITLE\">Session Group</div><div \ntranslate=\"PAGE.SESSION_GROUP.SUB_TITLE\" class=\"sub-title\">This is session group page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" ng-if=\"vm.actionPermit.view\" aria-label=\"filter\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nAssessment Date</label><md-select ng-model=\"vm.date\" class=\"md-accent md-hue-1\" name=\"assessmentDate\"><md-option \nng-repeat=\"val in vm.listDate\" ng-value=\"val\">{{val}}</md-option></md-select></md-input-container></div></md-toolbar>\n<div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" class=\"container\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" ms-responsive-table><thead><tr \nclass=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th class=\"text-center w-50\">ID</th><th \nclass=\"text-center\">NIK</th><th class=\"text-start\">NAME</th><th class=\"text-start\">POOL</th><th class=\"text-center\">\nTYPE</th><th class=\"text-center\">GUIDES</th><th class=\"text-center\">DURATION</th><th class=\"text-center\">Q-LIMIT</th>\n<th class=\"text-center\">START DATE</th><th class=\"text-center\">END DATE</th><th class=\"text-center\">START TIME</th><th \nclass=\"text-center\">END TIME</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr>\n</thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"14\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-center\">{{val.user.nik}}</td><td class=\"text-start\">\n{{val.user.name}}</td><td class=\"text-start\">{{val.question_pool.name}}</td><td class=\"text-center\">\n{{val.session_type | uppercase}}</td><td class=\"text-center\">{{val.guides.title}}</td><td class=\"text-center\">\n{{val.session_duration}}</td><td class=\"text-center\">{{val.question_limit == 0 ? \'NO LIMIT\' : val.question_limit}}</td>\n<td class=\"text-center\">{{val.session_start_date}}</td><td class=\"text-center\">{{val.session_end_date}}</td><td \nclass=\"text-center\">{{val.session_start_time}}</td><td class=\"text-center\">{{val.session_end_time}}</td><td \nclass=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" \nng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/guides/guides.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.GUIDES.TITLE\">Guides</div><div translate=\"PAGE.GUIDES.SUB_TITLE\" \nclass=\"sub-title\">This is guides page</div></div><div flex></div><div class=\"header-toolbox\"><md-button \naria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span></md-tooltip></md-button></div></div>\n<md-toolbar layout=\"row\" layout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\">\n<label>Total</label><md-select ng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option \nng-repeat=\"val in [5,15,20,25,50,100,150]\" ng-value=\"val\">{{val}}</md-option></md-select></md-input-container>\n<md-button aria-label=\"reload\" ng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"create\" ng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-center w-50\">ID</th><th class=\"text-start\">TITLE</th><th class=\"text-start\">CONTENT</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.title}}</td><td class=\"text-start\"><span \nng-bind-html=\"val.description\"></span></td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button \naria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/utility/menu/menu.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.MENU.TITLE\">Menu</div><div translate=\"PAGE.MENU.SUB_TITLE\" \nclass=\"sub-title\">This is menu page</div></div><div flex></div><div class=\"header-toolbox\"><md-button \naria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span></md-tooltip></md-button></div></div>\n<md-toolbar layout=\"row\" layout-align=\"start center\" class=\"md-background md-hue-3 toolbar\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" flex-gt-sm=\"30\" flex layout-align=\"start center\"><md-input-container flex \nclass=\"wrapper-input\"><label>Group</label><md-select ng-model=\"vm.group\" class=\"md-accent md-hue-1\" name=\"group\">\n<md-option ng-selected=\"vm.group == val.id\" ng-repeat=\"val in vm.listGroup\" ng-value=\"val.id\">{{val.name}}</md-option>\n</md-select></md-input-container><md-button aria-label=\"reload\" ng-disabled=\"!vm.group || vm.isLoading\" \nng-click=\"vm.loadData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></md-button></div></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div layout=\"row\" ng-show=\"!vm.isLoading\" \nclass=\"menu-container animate-fade-in-out\"><md-list flex ng-cloak><md-list-item ng-repeat-start=\"item in vm.listMenu\">\n<md-icon class=\"primary-fg\" md-font-icon=\"{{item.icon}}\"></md-icon><p>{{ item.title }}</p><md-switch \nng-change=\"vm.switchMenu(item)\" class=\"md-secondary\" ng-model=\"item.checked\"></md-switch></md-list-item><div \nng-if=\"item.actions.length > 0 && item.checked\" class=\"actions-wrapper md-primary-bg md-hue-2\" layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"h3\">Actions</div><div layout=\"row\" layout-wrap \nlayout-align=\"space-between start\"><md-switch flex-gt-sm ng-change=\"vm.switchAction(action)\" ng-model=\"action.checked\" \nng-repeat=\"action in item.actions\">{{action.actions}}</md-switch></div></div><div \nclass=\"child-wrapper padding-left-30 padding-right-30\" ng-if=\"item.childs.length > 0 && item.checked\"><md-list-item \nng-repeat-start=\"child in item.childs\"><md-icon class=\"primary-fg\" md-font-icon=\"{{child.icon}}\"></md-icon><p>\n{{ child.title }}</p><md-switch ng-change=\"vm.switchMenu(child)\" class=\"md-secondary\" ng-model=\"child.checked\">\n</md-switch></md-list-item><div ng-if=\"child.actions.length > 0 && child.checked\" \nclass=\"actions-wrapper md-primary-bg md-hue-3\" layout=\"column\" layout-align=\"space-between start\"><div class=\"h3\">\nActions</div><div layout=\"row\" layout-wrap layout-align=\"space-between start\"><md-switch \nng-change=\"vm.switchAction(action)\" flex-gt-sm ng-model=\"action.checked\" ng-repeat=\"action in child.actions\">\n{{action.actions}}</md-switch></div></div><md-divider ng-if=\"$index !== item.childs.length - 1\"></md-divider><span \nstyle=\"display: block; height: 10px\" ng-repeat-end></span></div><md-divider ng-repeat-end></md-divider></md-list></div>\n</md-content></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" class=\"md-primary-bg\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nmd-colors=\"{background: \'{{vm.theme}}-primary\'}\" class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"assets/images/avatars/{{vm.groupName}}.png\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.userName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content md-colors=\"{background: \'{{vm.theme}}-primary-600\', color: \'{{vm.theme}}-primary-100\' }\" \nwidth=\"3\"><md-menu-item md-colors=\"{color: \'{{vm.theme}}-primary-100\'}\" class=\"md-indent\"><md-icon \nmd-colors=\"{color: \'{{vm.theme}}-primary-100\'}\" md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/qa/pool/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-sm=\"70\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Category</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container flex \nclass=\"md-accent\"><label>Company</label><md-select ng-model=\"vm.data.company\" class=\"md-accent\" \nng-change=\"vm.onCompanyChange()\" name=\"company\"><md-option ng-repeat=\"val in vm.listCompany\" ng-value=\"val\">\n{{val | uppercase}}</md-option></md-select><div ng-messages=\"frmRequest.company.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container flex class=\"md-accent\"><label>Sub Area</label>\n<md-select ng-model=\"vm.data.sub_area_id\" class=\"md-accent\" name=\"sub_area\"><md-option \nng-selected=\"vm.data.sub_area_id == val.id\" ng-repeat=\"val in vm.listSubArea\" ng-value=\"val.id\">{{val.description}}\n</md-option></md-select><div ng-messages=\"frmRequest.sub_area.$error\"><div ng-message=\"required\">This is required!\n</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>Name</label><input name=\"name\" \ntype=\"text\" placeholder=\"ex: Math\" required ng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Description</label><input name=\"description\" type=\"text\" placeholder=\"ex: Math Category\" required \nng-model=\"vm.data.description\"><div ng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-if=\"vm.dialogType === \'CREATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button \nng-if=\"vm.dialogType === \'UPDATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/category/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Category</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Code</label><input name=\"code\" type=\"text\" placeholder=\"ex: K\" required \nng-model=\"vm.data.code\"><div ng-messages=\"frmRequest.code.$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container><md-input-container class=\"md-accent\" flex><label>Name</label><input name=\"name\" \ntype=\"text\" placeholder=\"ex: Math\" required ng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Description</label><input name=\"description\" type=\"text\" placeholder=\"ex: Math Category\" required \nng-model=\"vm.data.description\"><div ng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-if=\"vm.dialogType === \'CREATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button \nng-if=\"vm.dialogType === \'UPDATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/qa-general/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" class=\"qa-general-component-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">{{vm.dialogType | titleCase }} Question</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-0\" ng-init=\"vm.setForm(frmRequest)\"><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\"><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Question Category</label><md-select name=\"category_id\" required \nng-readonly=\"vm.errorInit\" placeholder=\"Question Category\" ng-model=\"vm.data.category_id\"><md-option ng-value=\"val.id\" \nng-selected=\"vm.data.category_id == val.id\" ng-repeat=\"val in vm.listQuestionCategory\">{{val.description}}</md-option>\n</md-select><div ng-messages=\"frmRequest.category_id.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>Question Pool</label><md-select name=\"pool_id\" \nrequired ng-readonly=\"vm.errorInit\" placeholder=\"Question Pool\" ng-model=\"vm.data.pool_id\"><md-option \nng-value=\"val.id\" ng-selected=\"vm.data.pool_id == val.id\" ng-repeat=\"val in vm.listQuestionPool\">{{val.description}}\n</md-option></md-select><div ng-messages=\"frmRequest.pool_id.$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container></div><div layout-gt-sm=\"row\" layout=\"column\" class=\"question-container\"><div \nflex-gt-sm=\"20\" layout=\"column\" class=\"question-type\"><p>Question Type</p><md-radio-group layout-xs=\"row\" \nng-model=\"vm.data.question_type\"><md-radio-button value=\"normal\" class=\"md-accent\">Multiple</md-radio-button>\n<md-radio-button ng-disabled=\"true\" class=\"md-accent\" value=\"math\">Math</md-radio-button></md-radio-group></div>\n<text-angular flex-gt-sm=\"80\" ng-model=\"vm.data.question\"></text-angular></div><div layout=\"column\" \nclass=\"upload-field\"><div layout=\"row\" layout-align=\"start\"><img ng-show=\"frmRequest.image_temp.$valid\" \nngf-thumbnail=\"vm.data.image_temp\"><md-button class=\"md-warn small-8\" ng-click=\"vm.data.image_temp = null\" \nng-show=\"vm.data.image_temp\"><md-icon md-font-icon=\"icon-close\"></md-icon><span>remove</span></md-button></div><input \ntype=\"file\" ngf-select ng-model=\"vm.data.image_temp\" name=\"image_temp\" accept=\"image/*\" ngf-max-size=\"2MB\" \nngf-model-invalid=\"vm.errorImage\"><div ng-show=\"frmRequest.image_temp.$error.maxSize\"><span \nclass=\"text-boxed md-warn-fg\">File too large {{errorImage.size / 1000000|number:1}} MB: max 2M</span></div></div><div \nlayout=\"column\"><div layout=\"row\" class=\"answer-container\" layout-align=\"start center\" \nng-repeat=\"item in vm.data.answers\"><md-button ng-click=\"vm.minAnswer($index)\" class=\"md-icon-button md-warn\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><div layout=\"column\" flex layout-align-sm=\"start center\" \nlayout-gt-sm=\"row\"><md-input-container class=\"answer-content\" flex-gt-sm=\"80\" flex-xs=\"100\"><label>\nAnswer {{vm.indexToAbjact($index)}}</label><textarea name=\"answer-{{$index}}\" required md-no-float \nplaceholder=\"Your answer here\" ng-model=\"item.answer\" rows=\"1\"></textarea><div \nng-messages=\"frmRequest[\'answer-\'+$index].$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-checkbox ng-model=\"item.flag\" aria-label=\"Answer {{$index}}\" ng-true-value=\"1\" \nng-false-value=\"0\" class=\"md-warn md-align-top-left\" flex>{{item.flag == 1 ? \'Correct\' : \'Wrong\'}}</md-checkbox></div>\n</div><div layout=\"row\"><md-button flex=\"100\" ng-click=\"vm.addAnswer()\" \nclass=\"md-raised md-accent w-auto margin-left-0 margin-right-0\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n</md-button></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.errorInit || vm.isLoading\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button \nng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.errorInit || vm.isLoading\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/qa-general/upload/upload.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" class=\"qa-general-upload-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">Upload Question</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"padding-0\" ng-init=\"vm.setForm(frmRequest)\"><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\"><div layout=\"row\"><md-input-container class=\"md-accent\" flex><label>\nQuestion Pool</label><md-select name=\"pool_id\" required ng-readonly=\"vm.errorInit\" placeholder=\"Question Pool\" \nng-model=\"vm.data.pool_id\"><md-option ng-value=\"val.id\" ng-selected=\"vm.data.pool_id == val.id\" \nng-repeat=\"val in vm.listQuestionPool\">{{val.description}}</md-option></md-select><div \nng-messages=\"frmRequest.pool_id.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n</div><div layout=\"column\"><input type=\"file\" ngf-select required ng-model=\"vm.data.file\" name=\"file\" \nngf-pattern=\"\'.xls,.xlsx\'\" ngf-max-size=\"2MB\" ngf-model-invalid=\"vm.errorFile\"><div class=\"margin-top-10\" \nng-show=\"frmRequest.file.$error.maxSize\"><span class=\"text-boxed md-warn-fg margin-0\">\nFile too large {{errorFile.size / 1000000|number:1}} MB: max 2M</span></div><div class=\"margin-top-10\" \nng-show=\"frmRequest.file.$error.pattern\"><span class=\"text-boxed md-warn-fg margin-0\">\nFile Extension must be .xls or .xlsx</span></div></div><div class=\"margin-top-10 error-log-container\" \nng-if=\"vm.isErrorUpload\" layout=\"column\"><md-subheader class=\"md-warn\">Upload Logs</md-subheader><table class=\"simple\">\n<thead><tr><th>Issues</th><th>Status</th><th>Messages</th></tr></thead><tbody><tr class=\"clickable\" \nng-if=\"key !== \'status\'\" ng-repeat-start=\"(key, val) in vm.validationLog\"><td>{{key}}</td><td>\n{{val.status ? \'SUCCESS\' : \'FAIL\'}}</td><td><div>{{val.message}}</div><div class=\"text-center\" \nng-if=\"key === \'headers\'\"><span ng-repeat=\"head in val.validation\" class=\"md-warn-fg margin-horizontal-10\">{{head}}\n</span></div></td></tr><tr ng-repeat-end ng-if=\"key === \'data\' && !val.status\"><td colspan=\"3\"><md-list \nclass=\"md-dense\"><md-subheader>Details</md-subheader><md-list-item ng-repeat-start=\"item in val.validation\" \nng-click=\"item.isCollapse = !item.isCollapse\"><div layout=\"row\"><div class=\"w-50 margin-right-10\">Row - {{ item.no }}\n</div><div ng-class=\"{\'green-400-fg\': item.is_valid, \'red-400-fg\': !item.is_valid}\">\n{{item.is_valid ? \'SUCCESS\' : \'FAIL\'}}</div></div></md-list-item><md-divider></md-divider><md-list-item \nng-if=\"item.isCollapse\" ng-repeat=\"more in item.validation\"><div class=\"error-details\" layout=\"column\"><div \nlayout=\"row\"><div class=\"w-150 margin-right-10\">{{ more.key | uppercase }}</div><div class=\"w-70 margin-right-10\" \nng-class=\"{\'green-400-fg\': more.status, \'red-400-fg\': !more.status}\">{{more.status ? \'SUCCESS\' : \'FAIL\'}}</div><div \nng-class=\"{\'red-400-fg\': !more.status}\">{{ more.message }}</div></div></div></md-list-item><md-divider ng-repeat-end>\n</md-divider></md-list></td></tr></tbody></table></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-disabled=\"vm.isLoading || frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event)\">UPLOAD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/enrollment/session-group/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" class=\"session-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">{{vm.dialogType | titleCase }} Classroom</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>Question Pool</label><md-select \nng-model=\"vm.data.question_pool_id\" required placeholder=\"Select Question Pool\" name=\"question_pool\"><md-option \nng-selected=\"item.id == vm.data.question_pool_id\" ng-repeat=\"item in vm.questionPool\" ng-value=\"item.id\">\n{{item.description}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"frmRequest.question_pool.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>Guides</label><md-select \nng-model=\"vm.data.guides_id\" required placeholder=\"Select Guides\" name=\"guides\"><md-option \nng-selected=\"item.id == vm.data.guides_id\" ng-repeat=\"item in vm.guides\" ng-value=\"item.id\">{{item.description}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.guides.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-accent\" flex><label>Session Type</label><md-select ng-model=\"vm.data.session_type\" \nrequired placeholder=\"Select Session Type\" name=\"session_type\"><md-option ng-selected=\"item == vm.data.session_type\" \nng-repeat=\"item in vm.sessionType\" ng-value=\"item\">{{item | uppercase}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.session_type.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>\nDuration (in minutes)</label><input name=\"duration\" type=\"number\" placeholder=\"ex: 30\" required \nng-model=\"vm.data.session_duration\"><div ng-messages=\"frmRequest.duration.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>\nQuestion Limit (0 for no limit)</label><input name=\"question_limit\" type=\"number\" placeholder=\"ex: 10\" required \nng-model=\"vm.data.question_limit\"><div ng-messages=\"frmRequest.question_limit.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex-gt-sm=\"10\" flex><label>\nOrder</label><input name=\"session_order\" type=\"number\" placeholder=\"ex: 1\" required ng-model=\"vm.data.session_order\">\n<div ng-messages=\"frmRequest.session_order.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>\nStart Date</label><input name=\"session_start_date\" type=\"date\" required ng-model=\"vm.tmpStartDate\"><div \nng-messages=\"frmRequest.session_start_date.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>Start Time</label><input \nname=\"session_start_time\" type=\"time\" required ng-model=\"vm.tmpStartTime\"><div \nng-messages=\"frmRequest.session_start_time.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>\nEnd Date</label><input name=\"session_end_date\" type=\"date\" required ng-model=\"vm.tmpEndDate\"><div \nng-messages=\"frmRequest.session_end_date.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>End Time</label><input name=\"session_end_time\" \ntype=\"time\" required ng-model=\"vm.tmpEndTime\"><div ng-messages=\"frmRequest.session_end_time.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"column\"><md-autocomplete md-delay=\"1000\" flex md-selected-item=\"vm.user\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match placeholder=\"Search Users\" \nmd-clear-button=\"true\" md-search-text=\"vm.searchText\" md-input-name=\"users\" md-floating-label=\"Search Users\" \nmd-no-cache=\"false\" md-menu-class=\"autocomplete-custom-template\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"vm.getItemText(item)\" md-min-length=\"2\"><md-item-template><span class=\"item-title\" \nmd-highlight-text=\"vm.searchText\">{{ vm.getItemText(item) | uppercase}}</span></md-item-template><div \nclass=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.users.$error\" role=\"alert\"><div ng-message=\"required\">\nThis is required</div></div><md-not-found>No Record matching \"{{vm.searchText}}\" were found.</md-not-found>\n</md-autocomplete><div layout=\"row\"><fieldset><legend>List Users</legend><md-list flex><md-list-item \nclass=\"md-no-proxy\" class=\"md-2-line\" ng-repeat-start=\"item in vm.data.users\"><md-button \nng-click=\"vm.removeUsers($index)\" class=\"md-secondary md-icon-button md-warn\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><div class=\"md-list-item-text\"><h3>{{item.nik}}</h3><p>{{item.name}}</p></div></md-list-item>\n<md-divider ng-repeat-end></md-divider></md-list></fieldset></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">\n{{vm.errorMessage}} </span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.data.users.length === 0\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.data.users.length === 0\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/guides/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Guides</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Title</label><input name=\"title\" type=\"text\" placeholder=\"ex: General Instructions\" \nrequired ng-model=\"vm.data.title\"><div ng-messages=\"frmRequest.title.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><div layout=\"column\" class=\"ta-container\"><div class=\"title\">Content\n</div><text-angular ng-model=\"vm.data.description\"></text-angular></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/guides/view/view.html","<md-dialog aria-label=\"View Dialog\" flex-gt-md=\"70\" class=\"view-dialog\" md-theme=\"{{vm.theme}}\"><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.data.title | titleCase}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.isErrorLoad\" \nclass=\"view-error\">{{vm.data.title | titleCase}} not found</div><embed ng-src=\"{{vm.guide}}\" ng-if=\"!vm.isErrorLoad\" \nwidth=\"100%\" height=\"400\"><md-button ng-disabled=\"vm.isErrorLoad\" class=\"md-icon-button md-accent\" \nng-click=\"vm.download()\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/clients/toolbar/view-guide/view-guide.html","<md-dialog aria-label=\"View Guide Dialog\" flex-gt-md=\"70\" flex-gt-sm=\"80\" class=\"view-dialog\" md-theme=\"{{vm.theme}}\">\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">GUIDE</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><view-pdf src=\"vm.guide\"></view-pdf></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout=\"start center\"><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-11/template-11.html","<div class=\"template-11 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.group_name\">{{card.group_name}}</div><div class=\"event h2\" \nng-if=\"card.pool_name\">{{card.pool_name}}</div></div><div class=\"media ml-16\"><md-button ng-click=\"card.callback\">\n</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);